// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-08T21:16:46.568Z
// Property: V Esprit (ID: 6767906449166793)
// Collections: 31 amenities, 4 floorplans (live), 100 photos, 39 POIs, 9 reviews, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166793",
  "property_external_id": "y2p1cpv",
  "property_zillow_url": "https://www.zillow.com/homedetails/5240-S-Shalom-Park-Cir-112688923-Aurora-CO-80015/349665846_zpid/",
  "property_apartments_url": "https://www.apartments.com/5240-s-shalom-park-cir-aurora-co/y2p1cpv/",
  "property_google_business_url": "https://www.google.com/maps/place/V-Espirit/data=!4m2!3m1!1s0x0:0xd3fbddb325d0ecba?sa=X&ved=2ahUKEwiYjOaS5qeSAxUKQjABHbpDFX8Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/in/peter-torrens-0585999",
  "property_hubspot_id": "41615633440",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "112VSP",
  "property_status": null,
  "property_slug": "v-esprit",
  "property_name": "V Esprit",
  "property_website_url": "https://www.v-esprit.com/",
  "property_domain": "https://v-esprit.com/",
  "property_address": "5240 South Shalom Park Circle",
  "property_full_address": "5240 S Shalom Park Cir, Aurora, CO 80015, USA",
  "property_address_1": "5240 South Shalom Park Circle",
  "property_address_2": null,
  "property_address_city": "Aurora",
  "property_address_state": "CO",
  "property_address_zip_full": null,
  "property_address_zip": "80015",
  "property_address_country": "US",
  "property_address_county": "Arapahoe County",
  "property_neighborhood_address": "Shenandoah",
  "property_address_latitude": "39.621132",
  "property_address_longitude": "-104.8150862",
  "property_email": "Liz Frost",
  "property_phone": "303-400-2399",
  "property_call_tracking_phone": null,
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At V Esprit in Aurora, CO, your ideal home awaits amid breathtaking mountain views and lush, landscaped grounds. Choose from stylish one- or two-bedroom floor plans, then unwind at our cocktail bar, or enjoy leisure in our award-winning pool. Experience luxury living designed for both relaxation and connection. ",
  "property_long_description": "Welcome to V Esprit, your luxurious retreat nestled in the heart of Aurora, CO. With thoughtfully designed floor plans featuring spacious one-bedroom and two-bedroom apartments, V Esprit offers an inviting atmosphere that feels like home. Our stunning community is equipped with an array of top-tier amenities to suit every lifestyle, including a cocktail bar for relaxed evenings, serene indoor relaxation areas, and a state-of-the-art theater for movie nights.\n\nStep outside to explore our beautifully landscaped 14-acre campus that boasts spectacular mountain views, inviting walking paths, and outdoor patio spaces perfect for gatherings. For those who love staying active, enjoy our award-winning swimming pool with lap lanes, a resistant-current channel, and jetted seating areas. Engage in aerobic and fitness classes in our group exercise area, or utilize our advanced Cybex® cardio and strength machines.\n\nAt V Esprit, you’ll find diverse gathering spaces, including a cozy library, lounge areas with fireplaces, and fun spots like a game nook and bocce ball court. The on-campus bistro and beauty salon ensure you have everything you need right at your doorstep, while membership to our fully equipped fitness center is included with your residence.\n\nWith shopping and dining just a stone's throw away and the beautiful Cherry Creek State Park nearby, V Esprit blends convenience with community living. Don’t miss the opportunity to be part of this exceptional lifestyle!\n\nFind your new home today—browse our availability or schedule a tour to visit our community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-09e6-7228-b997-992d06995384.webp",
  "property_featured_image_media": {
    "alt_text": "Row of modern apartment buildings with dramatic sunset sky.",
    "public_id": "019fba1f-09e6-7228-b997-992d06995384",
    "storage_key": "property/6767906449166793/019fba1f-09e6-7228-b997-992d06995384.webp",
    "width": 3072,
    "height": 2049
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166793/019fba26-2069-711c-aa77-1a578574ab35.mp4",
  "property_featured_video_media": {
    "public_id": "019fba26-2069-711c-aa77-1a578574ab35",
    "storage_key": "property/6767906449166793/019fba26-2069-711c-aa77-1a578574ab35.mp4",
    "thumbnail_key": "property/6767906449166793/019fba26-2069-711c-aa77-1a578574ab35_thumb.webp",
    "size_bytes": 199700084,
    "classification": "Community",
    "title": "Discover a Vibrant Community with Engaging Activities and Beautiful Surroundings",
    "description": "Explore our community's inviting amenities, from recreational spaces like the billiards room to serene outdoor gardens. Experience a fulfilling lifestyle designed for comfort and connection."
  },
  "property_total_units": "100",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "65.19",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "No Pets",
  "property_pet_policy_description": "No Pets",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://www.myrentalapplication.com/index/amcvesprit",
  "property_resident_portal_url": "https://v-esprit.com/residents/",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amcvesprit",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-1cdd-74a3-b7e9-25a03b51327a.webp",
  "property_primary_logo_media": {
    "alt_text": "V-Esprit Active Adult Community logo.",
    "public_id": "019d02cf-1cdd-74a3-b7e9-25a03b51327a",
    "storage_key": "property/6767906449166793/019d02cf-1cdd-74a3-b7e9-25a03b51327a.webp",
    "width": 452,
    "height": 247
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-bd9f-74e7-a08a-478eb34a5276.webp",
  "property_mono_white_logo_media": {
    "alt_text": "V-Esprit Active Adult Community logo",
    "public_id": "019d02d0-bd9f-74e7-a08a-478eb34a5276",
    "storage_key": "property/6767906449166793/019d02d0-bd9f-74e7-a08a-478eb34a5276.webp",
    "width": 452,
    "height": 247
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-c60e-748f-b63d-af649e290289.webp",
  "property_mono_black_logo_media": {
    "alt_text": "V-Esprit Active Adult Community logo",
    "public_id": "019d02d0-c60e-748f-b63d-af649e290289",
    "storage_key": "property/6767906449166793/019d02d0-c60e-748f-b63d-af649e290289.webp",
    "width": 452,
    "height": 247
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#bd1233",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#333333",
  "property_color_4": "#000000",
  "property_color_3": "#e2dfd6",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "725 - 1550",
  "property_sqft_min": "725",
  "property_sqft_max": "1550",
  "property_price_range": " - ",
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": null,
  "property_facebook_url": "https://www.facebook.com/liveavibrantlifestyle",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJOY0ywemIbIcRuuzQJbPd-9M",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=1+Bathroom+Apartment+Rental&find_loc=Centennial%2C+CO",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to V Esprit",
  "property_home_romance_title": "Embrace the Community, Find Your Perfect Home Today",
  "property_home_amenities_blurb": "At V Esprit in Aurora, CO, your dream lifestyle awaits! Choose from stylish one- or two-bedroom floor plans and indulge in top-tier amenities including a serene cocktail bar, inviting lounge areas, and award-winning pools. With breathtaking mountain views and lush grounds, every day feels like a retreat.",
  "property_home_floorplans_blurb": "At V Esprit in Aurora, CO, your dream apartment awaits! With a variety of thoughtfully designed floor plans, each home boasts comfort and style. Embrace modern living paired with vibrant community amenities. Browse our available options to find the space that perfectly suits your lifestyle today!",
  "property_home_gallery_blurb": "At V Esprit in Aurora, CO, luxury meets leisure on our beautifully landscaped 14-acre campus. Enjoy scenic mountain views from our cocktail bar, indulge in wellness classes, or unwind in the serene library. With amenities like a state-of-the-art fitness center and award-winning pool, picture yourself thriving here!",
  "property_home_neighborhood_blurb": "At V Esprit in Aurora, CO, comfort meets vibrant community living. Choose from spacious one- and two-bedroom floor plans, then venture out to enjoy nearby attractions like the Museum of Outdoor Arts and Cherry Creek State Park. Experience life's best moments at our lively apartment community—see what's around!",
  "property_home_reviews_blurb": "At V Esprit in Aurora, CO, residents rave about their vibrant community experience, noting, “the friendly atmosphere and beautiful surroundings make every day feel like a getaway.” Dive into authentic testimonials and see what makes our apartment community truly special—your new home awaits just a click away!",
  "property_neighborhood_blurb": "At V Esprit in Aurora, CO, vibrant living meets convenience. Step outside your new home to enjoy nearby gems like the Museum of Outdoor Arts and the Urban Air Trampoline Park. From parks to top-tier fitness centers, the best local attractions await just beyond your doorstep. See what’s around our community today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At V Esprit in Aurora, CO, your lifestyle blossoms amid scenic landscapes and top-tier amenities. Enjoy movie nights in our theater, unwind at the cocktail bar, or challenge friends on the bocce ball court. With stunning mountain views and an award-winning pool, life here is beautifully balanced and effortlessly vibrant.",
  "property_applynow_blurb": "At V Esprit in Aurora, CO, elevate your living experience amidst stunning mountain views and beautifully landscaped grounds. Choose from spacious one or two-bedroom floor plans and enjoy luxurious amenities, including a cocktail bar, award-winning swimming pool, and diverse gathering spaces. Your new home awaits—lease online today!",
  "property_contactus_blurb": "At V Esprit in Aurora, CO, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Whether you're seeking an intimate space or a roomy retreat, we’ve got the ideal layout for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At V Esprit in Aurora, CO, we offer thoughtfully designed One and Two Bedroom apartments to fit your lifestyle. Curious about our community? Our FAQs page is your go-to resource for answers and insights. Dive in and learn more about life at V Esprit today!",
  "property_floorplans_blurb": "At V Esprit in Aurora, CO, your ideal living space awaits. Choose from spacious one or two-bedroom floor plans designed to meet your lifestyle needs. Each layout maximizes comfort and style—perfect for relaxing or entertaining. Browse our available apartment homes and envision your new beginning today!",
  "property_gallery_blurb": "At V Esprit in Aurora, CO, visualize your life amidst stunning mountain views, vibrant amenities, and beautifully landscaped grounds. Indulge in the cocktail bar, soak in the award-winning pool, or unwind by the fireplace. With inviting spaces for work and play, your perfect home awaits—imagine living here!",
  "property_interactivemap_blurb": "At V Esprit in Aurora, CO, enjoy life amidst stunning mountain views and beautifully landscaped grounds. With diverse floor plans, fabulous amenities including a cocktail bar, theater, and award-winning pool, your ideal living space awaits. Unwind in lounges or embrace outdoor fun with walking paths and bocce ball—visit our interactive community map today!",
  "property_pets_blurb": "At V Esprit in Aurora, CO, experience an unparalleled lifestyle where modern elegance meets vibrant community living. With thoughtfully designed interiors and stunning amenities, every detail is crafted for comfort. Enjoy the convenience of city life while retreating to your serene home—an oasis waiting just for you. No pets allowed.",
  "property_referafriend_blurb": "At V Esprit in Aurora, CO, spacious one and two-bedroom floor plans are designed for comfort and style. Great friends make great neighbors—refer a friend to our vibrant community and enjoy the benefits of living next to those you cherish. Together, create lasting memories in your new home!",
  "property_residentaccess_blurb": "Welcome to V Esprit in Aurora, CO, where comfort meets convenience. Whether you're cozying up in a stylish one-bedroom or accommodating loved ones in a spacious two-bedroom, we cater to your living preferences. Access your resident portal today to effortlessly handle rent, schedule maintenance, and enjoy all our community offers!",
  "property_reviews_blurb": "At V Esprit in Aurora, CO, residents rave about the inviting atmosphere and friendly neighbors, stating, \"The sense of community here is unparalleled.\" Dive into our reviews to learn more about the unique living experience that awaits you at V Esprit! See what our residents have to say about living at our community!",
  "property_created_at": "1762200921357",
  "property_scheduletour_blurb": "At V Esprit in Aurora, CO, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Embrace vibrant living with luxurious amenities and a welcoming community atmosphere. Schedule a tour today and hear first-hand why our residents love calling V Esprit home! Their stories await you!",
  "property_thankyou_blurb": "Thank you for reaching out to V Esprit in Aurora, CO! Your interest in our spacious one and two-bedroom floor plans is appreciated. Stay tuned—our dedicated team will connect with you soon to help you find your perfect home in our vibrant community. ",
  "property_virtualtours_blurb": "At V Esprit in Aurora, CO, our thoughtfully designed one and two-bedroom apartments cater to your lifestyle. Experience the elegance and comfort of our community. Ready to find your new home? Step into your future with a virtual tour of our inviting spaces today!",
  "property_copyright": "2025 All Rights Reserved. V Esprit",
  "property_seo_title_home": "V Esprit |  Apartments in Aurora, CO",
  "property_seo_description_home": "Discover luxury at V Esprit in Aurora, CO! Enjoy mountain views, a rooftop bar, and vibrant spaces. Your dream home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Aurora, CO Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal floor plan at V Esprit in Aurora, CO. Choose from stylish one and two-bedroom apartments designed for comfort and convenience. Live your dream!",
  "property_seo_title_amenities": "Amenities | Aurora, CO Apartments for Rent",
  "property_seo_description_amenities": "Discover elevated living at V Esprit in Aurora, CO, with breathtaking mountain views, luxe amenities, and endless activities on a stunning campus.",
  "property_seo_title_gallery": "Gallery | Apartments in Aurora, CO",
  "property_seo_description_gallery": "Discover V Esprit in Aurora, CO: stunning mountain views, lavish amenities, and a vibrant community. Picture your dream home here!",
  "property_seo_title_virtualtours": "Virtual Tours | V Esprit Apartments",
  "property_seo_description_virtualtours": "Explore V Esprit in Aurora, CO! Take a virtual tour of our stylish one and two-bedroom apartments. Your new home is waiting!",
  "property_seo_title_interactivemap": "Interactive Map | V Esprit Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at V Esprit in Aurora, CO. Enjoy stunning mountain views, a cocktail bar, and a vibrant community. Explore our interactive map today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Aurora, CO",
  "property_seo_description_neighborhood": "Experience life at V Esprit in Aurora, CO! Uncover local gems and vibrant hotspots just steps from your new home. Dive into the neighborhood today!",
  "property_seo_title_contact": "Contact Us | V Esprit",
  "property_seo_description_contact": "Connect with our leasing team at V Esprit in Aurora, CO! Inquire about our one and two-bedroom floor plans and make your dream home a reality today!",
  "property_seo_title_faqs": "FAQs | Apartments in Aurora, CO",
  "property_seo_description_faqs": "Find answers to your questions about V Esprit in Aurora, CO! Learn about our luxurious amenities, floor plans, and vibrant community life. Your comfort awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Aurora, CO",
  "property_seo_description_reviews": "Experience life at V Esprit in Aurora, CO! From vibrant social spaces to serene mountain views, hear what our residents love about their home sweet home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Aurora, CO",
  "property_seo_description_applynow": "Discover luxury at V Esprit in Aurora, CO! Enjoy mountain views, a cocktail bar, an award-winning pool, and a vibrant community. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | V Esprit",
  "property_seo_description_residentaccess": "Welcome to V Esprit in Aurora, CO! Log in to your resident portal for easy rent payments, maintenance requests, and exclusive community updates.",
  "property_seo_title_referafriend": "Refer A Friend | V Esprit",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to V Esprit in Aurora, CO, and enjoy the perks of living in a vibrant, welcoming community together!",
  "property_seo_title_scheduletour": "Schedule a Tour | V Esprit",
  "property_seo_description_scheduletour": "Experience vibrant living at V Esprit in Aurora, CO. Schedule a tour today and envision your new home amidst modern comforts and stunning surroundings!",
  "property_seo_title_privacy": "Privacy Policy | V Esprit",
  "property_seo_description_privacy": "Your privacy matters at V Esprit in Aurora, CO. Safeguarding your data is our priority. View our privacy policy to learn how we protect your information.",
  "property_seo_title_accessibility": "Website Accessibility | V Esprit",
  "property_seo_description_accessibility": "At V Esprit in Aurora, CO, we prioritize accessibility and digital inclusion, ensuring everyone can enjoy the comfort of their new home. Join us today!",
  "property_seo_title_sitemap": "Sitemap | V Esprit",
  "property_seo_description_sitemap": "Find your way around V Esprit in Aurora, CO! Navigate our sitemap to explore amenities, floor plans, and community highlights. Your future home awaits!",
  "property_seo_title_thankyou": "Thank You | V Esprit",
  "property_seo_description_thankyou": "Thank you for reaching out to V Esprit in Aurora, CO! Stay tuned—our team will connect with you soon to help you find your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Aurora, CO",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293621357",
  "amenities": [
    {
      "id": "custom_0f84a6d0-45c8-4e9c-9c20-4c26268f4002",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Cocktail Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8779c332-239d-496d-8a58-f946393bce28",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Indoor relaxation areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_684368a9-56a3-417c-9a76-67c56b14cff9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Theater",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_532ced0c-ffc3-4f70-9799-37c305f794e4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Library",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_37643f85-3042-4cb2-881b-31eda54a891a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9e486f52-5410-4896-b145-6d9845e8f5cd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Lounge areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c8506a7d-59e4-4068-8605-2c0ebb22c427",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Putting Green",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f0a3599-a8fd-4264-9708-d3f52e7e2e19",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Bocce Ball Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_96ebff86-b978-4cc0-8fbd-50d648026824",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Spectacular Mountain Views",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e9c2a558-ca6b-43d8-b737-09c7a402346d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Cherry Creek State Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3a03a777-4450-4b40-b2b7-9a3f37722610",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Walking Paths",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d9a62a9-e457-4c23-93ed-b9dc778653f7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Patio spaces",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_08f295ad-85ce-4f61-954b-88de98989d72",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "14‑Acre Campus",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4a73b375-213f-409f-81ae-9ccfb8313097",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Close to shopping and dining",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f06dfdf-5934-48cb-b575-260a71f7a581",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Beautifully landscaped grounds",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3829b2c3-73cd-4d5d-94a1-20051a91ebe8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Water features",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3b4645a4-121c-4745-83e5-39b3e091792e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Sitting areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_81b7e428-ecc1-4f8c-8a44-109302e0c25e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Membership to the on‑campus Center is included",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3d0774e4-6181-4a92-80f5-e7c55b805e67",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Award‑winning swimming pool with lap lanes",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d110e31a-8c25-4be1-be65-9cd4bee021fe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Resistant‑current channel",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bac94465-1315-4392-b551-1230f17d5eaf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Jetted seating areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_68d129c8-80d3-41a7-adb6-1770c0d27419",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "UV light filtration system",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bcdee80a-73c6-4312-8a98-221c855c442f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Aerobic and fitness classes",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8817aa3-e0f7-4f79-9406-124158c74af0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Group exercise area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_72a9c04f-6873-4735-a7a9-ee0274a14234",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Special shock‑absorbing floor",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_67524d91-7700-464f-a775-ce53a70e4541",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Cybex® cardio and strength machines",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d520e4df-bbf2-4718-aff9-4b9e111b688e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Beauty Salon and Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6782b959-b94b-46c5-9e1f-9e422925b3d1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Bistro",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5375cfc9-debd-4a16-b70a-647799adc749",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Wide variety of gathering and common spaces",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0eb11ba7-4835-4a7a-96ed-38f5d32cb16a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Business Nook",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_de9023e4-1350-4fd7-be6e-205aed38f4fc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "external_id": "false",
      "title": "Game Nook",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_0048a540-a015-4905-8cf4-387ce9bf9c76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba20-4027-7088-b4e6-555b8a5a47e6.webp",
      "image_media": {
        "alt_text": "V-Esprit Active Adult Community sign and apartment buildings",
        "public_id": "019fba20-4027-7088-b4e6-555b8a5a47e6",
        "storage_key": "property/6767906449166793/019fba20-4027-7088-b4e6-555b8a5a47e6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Signage for V-Esprit Active Adult Community, located at 5240 S. Shalom Park Circle. Apartment buildings are visible in the background.",
      "link": "",
      "alt_text": "V-Esprit Active Adult Community sign and apartment buildings",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a6b5342e-003a-481b-85dd-783e9d8db7b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba20-00df-7693-9584-42bb3b5cc62a.webp",
      "image_media": {
        "alt_text": "Spacious common area with large windows, comfortable seating, and decorative plants.",
        "public_id": "019fba20-00df-7693-9584-42bb3b5cc62a",
        "storage_key": "property/6767906449166793/019fba20-00df-7693-9584-42bb3b5cc62a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed common areas, featuring ample natural light and cozy seating arrangements.",
      "link": "",
      "alt_text": "Spacious common area with large windows, comfortable seating, and decorative plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a7e770f7-b318-4cba-9eb2-e83c0825fc1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-fc9f-747d-a730-5fce4597d79f.webp",
      "image_media": {
        "alt_text": "Row of modern townhomes with dark gray siding and stone accents.",
        "public_id": "019fba1f-fc9f-747d-a730-5fce4597d79f",
        "storage_key": "property/6767906449166793/019fba1f-fc9f-747d-a730-5fce4597d79f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Discover comfortable living in these modern townhomes, featuring stylish dark gray siding and elegant stone accents, nestled in a charming neighborhood.",
      "link": "",
      "alt_text": "Row of modern townhomes with dark gray siding and stone accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_12b099f3-6f6f-415d-8daa-4dd0cf6adaad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-fca2-7128-9671-14629810e1cf.webp",
      "image_media": {
        "alt_text": "Indoor swimming pool with curved sections and seating areas, large windows overlooking greenery.",
        "public_id": "019fba1f-fca2-7128-9671-14629810e1cf",
        "storage_key": "property/6767906449166793/019fba1f-fca2-7128-9671-14629810e1cf.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind in our stunning indoor swimming pool. Featuring unique curved sections and comfortable seating areas, it's the perfect place to de-stress.",
      "link": "",
      "alt_text": "Indoor swimming pool with curved sections and seating areas, large windows overlooking greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1f937a57-0db6-4b3a-8121-37734f150dc5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba20-01ee-71e5-bd72-fd59a18312f3.webp",
      "image_media": {
        "alt_text": "Aerial view of the entrance to a multifamily property with a covered walkway, parking lot, and outdoor seating areas.",
        "public_id": "019fba20-01ee-71e5-bd72-fd59a18312f3",
        "storage_key": "property/6767906449166793/019fba20-01ee-71e5-bd72-fd59a18312f3.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Welcome to our community, featuring a spacious entrance, ample parking, and inviting outdoor spaces for relaxation and socializing. Enjoy the convenience and comfort of our property.",
      "link": "",
      "alt_text": "Aerial view of the entrance to a multifamily property with a covered walkway, parking lot, and outdoor seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d205887a-5a60-4c90-8969-d920abdbfb11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-e7f1-737d-a1a2-2b2ee3176750.webp",
      "image_media": {
        "alt_text": "Indoor swimming pool with accessible ramp and seating areas.",
        "public_id": "019fba1f-e7f1-737d-a1a2-2b2ee3176750",
        "storage_key": "property/6767906449166793/019fba1f-e7f1-737d-a1a2-2b2ee3176750.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our beautiful indoor pool, complete with accessible entry and comfortable seating.",
      "link": "",
      "alt_text": "Indoor swimming pool with accessible ramp and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_393a14f5-83eb-4545-a465-954f641ffb70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-e7f1-72d7-a024-aee38585d15b.webp",
      "image_media": {
        "alt_text": "Covered outdoor patio area with tables, chairs, and ceiling fans.",
        "public_id": "019fba1f-e7f1-72d7-a024-aee38585d15b",
        "storage_key": "property/6767906449166793/019fba1f-e7f1-72d7-a024-aee38585d15b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy our spacious outdoor patio, complete with comfortable seating, ceiling fans, and scenic views, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Covered outdoor patio area with tables, chairs, and ceiling fans.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_72d1c307-5e17-4118-b641-7f0821438a32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-d5f2-752c-803c-093e37831d11.webp",
      "image_media": {
        "alt_text": "Poker table with chairs and movie posters on the wall.",
        "public_id": "019fba1f-d5f2-752c-803c-093e37831d11",
        "storage_key": "property/6767906449166793/019fba1f-d5f2-752c-803c-093e37831d11.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Gather your friends for a game night at the poker table, perfect for friendly competition.",
      "link": "",
      "alt_text": "Poker table with chairs and movie posters on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_139b0638-4312-44fb-a74c-59aa2fffa3bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-cdc8-75e8-a71e-269f91b38502.webp",
      "image_media": {
        "alt_text": "Community lounge area with salon chairs, counter space, and water cooler.",
        "public_id": "019fba1f-cdc8-75e8-a71e-269f91b38502",
        "storage_key": "property/6767906449166793/019fba1f-cdc8-75e8-a71e-269f91b38502.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax and unwind in our community lounge, featuring comfortable seating and amenities for your convenience.",
      "link": "",
      "alt_text": "Community lounge area with salon chairs, counter space, and water cooler.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5a616073-8cc5-4cd9-bbdb-668f7a2e8ce4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-b7c3-732a-843a-6d1fff20aa39.webp",
      "image_media": {
        "alt_text": "Living room with white leather sofa, striped armchairs, coffee table, and large windows.",
        "public_id": "019fba1f-b7c3-732a-843a-6d1fff20aa39",
        "storage_key": "property/6767906449166793/019fba1f-b7c3-732a-843a-6d1fff20aa39.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable white leather sofa, plush armchairs, and a decorative coffee table, all illuminated by abundant natural light from large windows.",
      "link": "",
      "alt_text": "Living room with white leather sofa, striped armchairs, coffee table, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_95671062-55ae-48ff-8f98-937e1cd7955f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-6bbd-731f-8e57-046f0ca0ebb3.webp",
      "image_media": {
        "alt_text": "Built-in bookshelves filled with books, located in a common area.",
        "public_id": "019fba1f-6bbd-731f-8e57-046f0ca0ebb3",
        "storage_key": "property/6767906449166793/019fba1f-6bbd-731f-8e57-046f0ca0ebb3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "A large collection of books displayed on dark wood shelves, creating a library-like atmosphere in a community space. Perfect for residents to browse and borrow.",
      "link": "",
      "alt_text": "Built-in bookshelves filled with books, located in a common area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_23af444c-8cbd-48f8-8cee-d1b4dde64271",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-68ba-779c-80cf-bf7dbc3c60e3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light gray cabinets, granite countertops, stainless steel appliances, and a mosaic tile backsplash.",
        "public_id": "019fba1f-68ba-779c-80cf-bf7dbc3c60e3",
        "storage_key": "property/6767906449166793/019fba1f-68ba-779c-80cf-bf7dbc3c60e3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring light gray cabinetry, elegant granite countertops, a stainless steel range and microwave, and a beautiful mosaic tile backsplash. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with light gray cabinets, granite countertops, stainless steel appliances, and a mosaic tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_49ade874-c634-4a17-9c49-2412a486f156",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-4de6-72a8-b209-bcc36ed5c586.webp",
      "image_media": {
        "alt_text": "Community dining area with a large table and chairs, adjacent to a bar and kitchen.",
        "public_id": "019fba1f-4de6-72a8-b209-bcc36ed5c586",
        "storage_key": "property/6767906449166793/019fba1f-4de6-72a8-b209-bcc36ed5c586.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy gathering with friends and neighbors in our spacious community dining area, featuring comfortable seating and a stylish bar perfect for socializing.",
      "link": "",
      "alt_text": "Community dining area with a large table and chairs, adjacent to a bar and kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4fc91413-202e-4561-9486-a5d32a286133",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-3e72-730d-9d67-72e3149a3e99.webp",
      "image_media": {
        "alt_text": "Shelves filled with boxes of jigsaw puzzles.",
        "public_id": "019fba1f-3e72-730d-9d67-72e3149a3e99",
        "storage_key": "property/6767906449166793/019fba1f-3e72-730d-9d67-72e3149a3e99.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Other",
      "description": "A collection of various jigsaw puzzle boxes displayed on wooden shelves, showcasing different scenes and piece counts, suggesting a hobby or activity.",
      "link": "",
      "alt_text": "Shelves filled with boxes of jigsaw puzzles.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dfd90738-e6bf-48f2-9e7b-d968eb6c49bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-316e-756c-acdf-068f107b4f95.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with neutral carpet and wall colors.",
        "public_id": "019fba1f-316e-756c-acdf-068f107b4f95",
        "storage_key": "property/6767906449166793/019fba1f-316e-756c-acdf-068f107b4f95.webp",
        "width": 3072,
        "height": 2043
      },
      "title": "Apartment",
      "description": "Expansive open-concept living area seamlessly flows into a modern kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Spacious living room and kitchen area with neutral carpet and wall colors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7da6a6af-e26a-4590-a9a9-5daabc923d2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-2db0-712a-958e-06cb44d614d0.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and large windows.",
        "public_id": "019fba1f-2db0-712a-958e-06cb44d614d0",
        "storage_key": "property/6767906449166793/019fba1f-2db0-712a-958e-06cb44d614d0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax in the spacious living room, featuring a cozy fireplace and ample natural light from large windows. A perfect space to unwind.",
      "link": "",
      "alt_text": "Living room with a fireplace and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fe9d84d5-9fbc-424c-bb32-2965d7ff2fda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-2006-71fe-9459-bcd9667ea8a3.webp",
      "image_media": {
        "alt_text": "Community room with dining tables, chairs, and artwork.",
        "public_id": "019fba1f-2006-71fe-9459-bcd9667ea8a3",
        "storage_key": "property/6767906449166793/019fba1f-2006-71fe-9459-bcd9667ea8a3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy our spacious community room, perfect for gatherings or a quiet meal, featuring comfortable seating and elegant decor.",
      "link": "",
      "alt_text": "Community room with dining tables, chairs, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_88f2d8c2-65bd-4e14-9ec8-4e0a48fcefa6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-0ff1-71bd-905a-7ba716f8b37a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, gray island, stainless steel appliances, and wood floors.",
        "public_id": "019fba1f-0ff1-71bd-905a-7ba716f8b37a",
        "storage_key": "property/6767906449166793/019fba1f-0ff1-71bd-905a-7ba716f8b37a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek stainless steel appliances, ample cabinet storage, and a large island perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, gray island, stainless steel appliances, and wood floors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4a5252de-15ad-4559-89e4-0b2423a6fbd0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-09e6-7228-b997-992d06995384.webp",
      "image_media": {
        "alt_text": "Row of modern apartment buildings with dramatic sunset sky.",
        "public_id": "019fba1f-09e6-7228-b997-992d06995384",
        "storage_key": "property/6767906449166793/019fba1f-09e6-7228-b997-992d06995384.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Beautifully lit apartment buildings at dusk, with a vibrant orange and purple sunset sky overhead. Experience modern living in a picturesque setting.",
      "link": "",
      "alt_text": "Row of modern apartment buildings with dramatic sunset sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_045773f9-83eb-49b5-8683-a343bd238136",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-0791-75f9-bff7-2066e3d9cba6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a decorative backsplash.",
        "public_id": "019fba1f-0791-75f9-bff7-2066e3d9cba6",
        "storage_key": "property/6767906449166793/019fba1f-0791-75f9-bff7-2066e3d9cba6.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Step into this beautifully updated kitchen featuring elegant granite countertops, a stylish mosaic backsplash, and modern stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a decorative backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4a45c511-0e00-4113-8201-70d09c22829c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-fc0f-738d-b5f5-476f5f221e04.webp",
      "image_media": {
        "alt_text": "Aerial view of a sprawling apartment complex with well-maintained landscaping and multiple buildings.",
        "public_id": "019fba1e-fc0f-738d-b5f5-476f5f221e04",
        "storage_key": "property/6767906449166793/019fba1e-fc0f-738d-b5f5-476f5f221e04.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover our vibrant community from an aerial perspective. This image showcases the beautiful grounds and architecture of our apartment complex, offering a glimpse into the serene living environment.",
      "link": "",
      "alt_text": "Aerial view of a sprawling apartment complex with well-maintained landscaping and multiple buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_12c2b168-8095-45bc-8e77-f519e874cbb8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-ef19-7673-be5a-673ffe234f1f.webp",
      "image_media": {
        "alt_text": "Outdoor dining area with table, chairs, and built-in grill on a balcony with a view.",
        "public_id": "019fba1e-ef19-7673-be5a-673ffe234f1f",
        "storage_key": "property/6767906449166793/019fba1e-ef19-7673-be5a-673ffe234f1f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and summer BBQs on your spacious balcony, complete with a full outdoor kitchen and seating area.",
      "link": "",
      "alt_text": "Outdoor dining area with table, chairs, and built-in grill on a balcony with a view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0482f27a-862b-4f51-b422-29e7fc259c5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-e901-72da-8c06-e2a2bd61462a.webp",
      "image_media": {
        "alt_text": "Exterior view of single-story apartment buildings with red awnings and landscaping.",
        "public_id": "019fba1e-e901-72da-8c06-e2a2bd61462a",
        "storage_key": "property/6767906449166793/019fba1e-e901-72da-8c06-e2a2bd61462a.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover comfortable living in our charming apartment community, featuring well-maintained exteriors and a serene atmosphere. Enjoy the beautiful surroundings and relax in your new home.",
      "link": "",
      "alt_text": "Exterior view of single-story apartment buildings with red awnings and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_714997f1-f474-42f9-b887-58644f25f7d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-e7c9-77fd-8566-3944dbe615b6.webp",
      "image_media": {
        "alt_text": "Spacious laundry room with washer, dryer, sink, and ample cabinet space.",
        "public_id": "019fba1e-e7c9-77fd-8566-3944dbe615b6",
        "storage_key": "property/6767906449166793/019fba1e-e7c9-77fd-8566-3944dbe615b6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern and functional laundry room featuring a full-size washer and dryer, a deep utility sink, and abundant storage with upper and lower cabinets, perfect for keeping your home organized.",
      "link": "",
      "alt_text": "Spacious laundry room with washer, dryer, sink, and ample cabinet space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5f17701c-a605-46f3-b659-0db52ed533e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-dbdc-7029-997d-0d46b569af05.webp",
      "image_media": {
        "alt_text": "Spacious living area with open kitchen and sunroom access.",
        "public_id": "019fba1e-dbdc-7029-997d-0d46b569af05",
        "storage_key": "property/6767906449166793/019fba1e-dbdc-7029-997d-0d46b569af05.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living space with a modern kitchen and a sunroom, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Spacious living area with open kitchen and sunroom access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_790899d0-5252-49b7-ae9a-9b15331fbe28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-da48-74d0-8455-7906b0362f49.webp",
      "image_media": {
        "alt_text": "Open double doors reveal a spacious living area and kitchen with modern appliances and island.",
        "public_id": "019fba1e-da48-74d0-8455-7906b0362f49",
        "storage_key": "property/6767906449166793/019fba1e-da48-74d0-8455-7906b0362f49.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this inviting apartment featuring a bright living space and a contemporary kitchen, perfect for everyday living and entertaining.",
      "link": "",
      "alt_text": "Open double doors reveal a spacious living area and kitchen with modern appliances and island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d6e02bfb-5d13-411d-a832-a63ea33534d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-d0ab-7000-8e8e-28adab4905a4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, granite countertops, and a stainless steel range and hood.",
        "public_id": "019fba1e-d0ab-7000-8e8e-28adab4905a4",
        "storage_key": "property/6767906449166793/019fba1e-d0ab-7000-8e8e-28adab4905a4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this beautifully appointed kitchen featuring sleek gray cabinetry, granite countertops, and a premium stainless steel appliance suite.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, granite countertops, and a stainless steel range and hood.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0bb7ea9c-9679-491a-b0ae-3241635bd994",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-cd46-7003-b811-ecee75efdf5d.webp",
      "image_media": {
        "alt_text": "Community garden with raised garden beds and stone pathway.",
        "public_id": "019fba1e-cd46-7003-b811-ecee75efdf5d",
        "storage_key": "property/6767906449166793/019fba1e-cd46-7003-b811-ecee75efdf5d.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy fresh produce from our community garden, featuring raised garden beds and a charming stone pathway.",
      "link": "",
      "alt_text": "Community garden with raised garden beds and stone pathway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6104ecd4-b581-4133-bfcd-2fea3c7c9e95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-cae8-74e3-9268-5ee771f292ca.webp",
      "image_media": {
        "alt_text": "Community room with tables and chairs, large TV, and a jukebox.",
        "public_id": "019fba1e-cae8-74e3-9268-5ee771f292ca",
        "storage_key": "property/6767906449166793/019fba1e-cae8-74e3-9268-5ee771f292ca.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Gather in our vibrant community room, perfect for socializing, events, or enjoying a game on the big screen. Featuring comfortable seating and a vintage jukebox.",
      "link": "",
      "alt_text": "Community room with tables and chairs, large TV, and a jukebox.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e4c11388-5d69-451a-8d90-a7f8ae4aa756",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-bc8d-7049-94f6-293d2bd048c0.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer unit in a closet",
        "public_id": "019fba1e-bc8d-7049-94f6-293d2bd048c0",
        "storage_key": "property/6767906449166793/019fba1e-bc8d-7049-94f6-293d2bd048c0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Convenient in-unit stackable washer and dryer.",
      "link": "",
      "alt_text": "Stackable washer and dryer unit in a closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3a2dd010-07d6-4fee-887e-4c038671e49c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-bb26-707f-8cfd-31d44d528e3a.webp",
      "image_media": {
        "alt_text": "View of an empty apartment room with large windows and a glass door.",
        "public_id": "019fba1e-bb26-707f-8cfd-31d44d528e3a",
        "storage_key": "property/6767906449166793/019fba1e-bb26-707f-8cfd-31d44d528e3a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "An empty apartment living area featuring large windows and a glass door leading outside, offering a bright and open space.",
      "link": "",
      "alt_text": "View of an empty apartment room with large windows and a glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3356c00d-4b04-4372-b115-ca661932aa93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-b3c3-75fd-9872-72cb50901134.webp",
      "image_media": {
        "alt_text": "Spacious living room with carpet and sliding glass doors leading to a balcony.",
        "public_id": "019fba1e-b3c3-75fd-9872-72cb50901134",
        "storage_key": "property/6767906449166793/019fba1e-b3c3-75fd-9872-72cb50901134.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and airy living space featuring plush carpeting and direct access to a private balcony, perfect for enjoying the outdoors.",
      "link": "",
      "alt_text": "Spacious living room with carpet and sliding glass doors leading to a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e893c2f1-32aa-4e34-b072-a0d6b9442de3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-a93f-720c-8aad-ac43dde136e2.webp",
      "image_media": {
        "alt_text": "Indoor gymnasium with wood floor, chairs, and recreational equipment.",
        "public_id": "019fba1e-a93f-720c-8aad-ac43dde136e2",
        "storage_key": "property/6767906449166793/019fba1e-a93f-720c-8aad-ac43dde136e2.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy indoor recreation in our spacious gymnasium, featuring a wood floor, seating areas, and equipment for various activities.",
      "link": "",
      "alt_text": "Indoor gymnasium with wood floor, chairs, and recreational equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8fbccd9-566b-4302-a759-4343e369f7ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-a6f6-718b-9f6f-922eb71d5fc5.webp",
      "image_media": {
        "alt_text": "Exterior view of the property entrance with a covered walkway, landscaping, and parking lot.",
        "public_id": "019fba1e-a6f6-718b-9f6f-922eb71d5fc5",
        "storage_key": "property/6767906449166793/019fba1e-a6f6-718b-9f6f-922eb71d5fc5.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Welcome to the property's main entrance, featuring a welcoming covered walkway, beautifully landscaped grounds, and convenient parking. Enjoy the outdoor amenities with seating areas under umbrellas.",
      "link": "",
      "alt_text": "Exterior view of the property entrance with a covered walkway, landscaping, and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_50510014-849f-4799-9eac-90a4dc02354e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-92dc-71f5-b8eb-e258b2b7cede.webp",
      "image_media": {
        "alt_text": "Outdoor patio with seating and tables, surrounded by a red railing, with buildings and trees in the background.",
        "public_id": "019fba1e-92dc-71f5-b8eb-e258b2b7cede",
        "storage_key": "property/6767906449166793/019fba1e-92dc-71f5-b8eb-e258b2b7cede.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy relaxing outdoors on the spacious patio, featuring comfortable seating and tables, perfect for socializing or unwinding amidst the beautiful scenery.",
      "link": "",
      "alt_text": "Outdoor patio with seating and tables, surrounded by a red railing, with buildings and trees in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7a38e1f0-1d6b-4962-b483-d8d7c91eac29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-9380-716a-bf76-11cfc4923da0.webp",
      "image_media": {
        "alt_text": "Billiard table in a community lounge area",
        "public_id": "019fba1e-9380-716a-bf76-11cfc4923da0",
        "storage_key": "property/6767906449166793/019fba1e-9380-716a-bf76-11cfc4923da0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy friendly competition or a relaxed evening in our billiards room, a great space to socialize with neighbors.",
      "link": "",
      "alt_text": "Billiard table in a community lounge area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_96a681ea-5322-4c88-b84b-ed103a2439a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-998c-772f-ac13-9d62de64c020.webp",
      "image_media": {
        "alt_text": "Interior of a multi-story apartment building lobby with seating areas and large windows overlooking a landscape.",
        "public_id": "019fba1e-998c-772f-ac13-9d62de64c020",
        "storage_key": "property/6767906449166793/019fba1e-998c-772f-ac13-9d62de64c020.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Spacious and inviting lobby area featuring comfortable seating, a fireplace, and large windows with scenic views, perfect for residents to relax and socialize.",
      "link": "",
      "alt_text": "Interior of a multi-story apartment building lobby with seating areas and large windows overlooking a landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de7f6ec2-fd34-45b5-b90b-e54e9f9b9da6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-90f5-711d-8d45-9f6b21571790.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a mosaic tile backsplash.",
        "public_id": "019fba1e-90f5-711d-8d45-9f6b21571790",
        "storage_key": "property/6767906449166793/019fba1e-90f5-711d-8d45-9f6b21571790.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this beautiful kitchen featuring stainless steel appliances, elegant granite countertops, and a stunning mosaic tile backsplash. Perfect for home chefs and entertainers alike.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a mosaic tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b0032ab4-0b63-4f64-be84-8adfc9013cb2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-7a29-735a-891f-251f00e8c1a8.webp",
      "image_media": {
        "alt_text": "Hallway with seating areas and a bar with stools",
        "public_id": "019fba1e-7a29-735a-891f-251f00e8c1a8",
        "storage_key": "property/6767906449166793/019fba1e-7a29-735a-891f-251f00e8c1a8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a comfortable and stylish hallway, complete with a bar area, seating, and decorative shelves.",
      "link": "",
      "alt_text": "Hallway with seating areas and a bar with stools",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e929ff4d-9a2e-4fa3-a820-6457b8d0b206",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-7124-71f9-93b1-ff7e4a5fa050.webp",
      "image_media": {
        "alt_text": "Poker table and seating area with entertainment posters on the wall.",
        "public_id": "019fba1e-7124-71f9-93b1-ff7e4a5fa050",
        "storage_key": "property/6767906449166793/019fba1e-7124-71f9-93b1-ff7e4a5fa050.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Gather your friends for a game night at the poker table in this community amenity space.",
      "link": "",
      "alt_text": "Poker table and seating area with entertainment posters on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a2e35c4-b40d-4b0e-8f1e-574cd06c2841",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-6b8f-73ff-b3c2-bf2e44bfbe61.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and pendant lighting.",
        "public_id": "019fba1e-6b8f-73ff-b3c2-bf2e44bfbe61",
        "storage_key": "property/6767906449166793/019fba1e-6b8f-73ff-b3c2-bf2e44bfbe61.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring stainless steel appliances, ample cabinet space, granite countertops, and a breakfast bar. Open to the living area for easy entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and pendant lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ff05cd1a-5ac7-439a-aa2f-346bf82478de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-64ed-73f8-bae0-fc90cfeed7cf.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, marble countertop, stainless steel fixtures, glass shower enclosure, and washer/dryer in a closet.",
        "public_id": "019fba1e-64ed-73f8-bae0-fc90cfeed7cf",
        "storage_key": "property/6767906449166793/019fba1e-64ed-73f8-bae0-fc90cfeed7cf.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious vanity with a marble countertop, a glass-enclosed shower, and a convenient in-unit washer and dryer.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, marble countertop, stainless steel fixtures, glass shower enclosure, and washer/dryer in a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f32eb501-e002-4528-b77b-3cf070fb0266",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-609b-765d-83ae-d5da0a72e01d.webp",
      "image_media": {
        "alt_text": "Outdoor courtyard with putting green and seating areas under red umbrellas.",
        "public_id": "019fba1e-609b-765d-83ae-d5da0a72e01d",
        "storage_key": "property/6767906449166793/019fba1e-609b-765d-83ae-d5da0a72e01d.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community putting green and comfortable seating areas, perfect for socializing or relaxing under the shade of red umbrellas.",
      "link": "",
      "alt_text": "Outdoor courtyard with putting green and seating areas under red umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b38406b8-d8f8-4f0a-9e44-2b210f1f07cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-5455-762d-b23e-2e65cdab3175.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with fireplace and large windows",
        "public_id": "019fba1e-5455-762d-b23e-2e65cdab3175",
        "storage_key": "property/6767906449166793/019fba1e-5455-762d-b23e-2e65cdab3175.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting common area, featuring a cozy fireplace and ample natural light from expansive windows.",
      "link": "",
      "alt_text": "Comfortable seating area with fireplace and large windows",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2bd0f354-507b-4933-b56d-bab471fb6d70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-521b-712d-9a00-edeef7d21bd1.webp",
      "image_media": {
        "alt_text": "Empty bedroom with beige carpet, white closet doors, and two windows with blinds.",
        "public_id": "019fba1e-521b-712d-9a00-edeef7d21bd1",
        "storage_key": "property/6767906449166793/019fba1e-521b-712d-9a00-edeef7d21bd1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "This spacious bedroom features neutral tones, plush beige carpeting, a convenient closet, and abundant natural light from two large windows.",
      "link": "",
      "alt_text": "Empty bedroom with beige carpet, white closet doors, and two windows with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_27f0b41e-7f63-429e-ae97-da57fa219ab4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-4b85-753b-9785-6aa0335fd010.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating and abstract art.",
        "public_id": "019fba1e-4b85-753b-9785-6aa0335fd010",
        "storage_key": "property/6767906449166793/019fba1e-4b85-753b-9785-6aa0335fd010.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring plush seating, contemporary decor, and a vibrant atmosphere perfect for socializing or quiet contemplation.",
      "link": "",
      "alt_text": "Modern lounge area with comfortable seating and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ec893499-3a60-41c1-bb5b-fc06edc11d7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-5086-7168-916c-15d897686311.webp",
      "image_media": {
        "alt_text": "Exterior of apartments with landscaping and blue sky.",
        "public_id": "019fba1e-5086-7168-916c-15d897686311",
        "storage_key": "property/6767906449166793/019fba1e-5086-7168-916c-15d897686311.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Charming apartment buildings with well-maintained landscaping and a clear blue sky, creating a welcoming atmosphere.",
      "link": "",
      "alt_text": "Exterior of apartments with landscaping and blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_63bc1d19-41b8-4f4c-920d-90104530e212",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-41d4-7350-b25b-634919d006ba.webp",
      "image_media": {
        "alt_text": "Community game room with a large Scrabble board and three bar stools.",
        "public_id": "019fba1e-41d4-7350-b25b-634919d006ba",
        "storage_key": "property/6767906449166793/019fba1e-41d4-7350-b25b-634919d006ba.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy endless fun in our community game room, featuring a large Scrabble board and comfortable seating. Perfect for resident get-togethers and friendly competition.",
      "link": "",
      "alt_text": "Community game room with a large Scrabble board and three bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4a2edefe-f0b6-4b16-ad97-637691b52fe4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-3e62-74eb-9d2b-62e4a2dd1cfd.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with treadmills, ellipticals, and weight machines overlooking scenic views.",
        "public_id": "019fba1e-3e62-74eb-9d2b-62e4a2dd1cfd",
        "storage_key": "property/6767906449166793/019fba1e-3e62-74eb-9d2b-62e4a2dd1cfd.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Well-equipped fitness center with treadmills, ellipticals, and weight machines overlooking scenic views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_09c7bfd9-f39a-420a-8711-d277dcd8a424",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-3208-707a-a352-040ac8942245.webp",
      "image_media": {
        "alt_text": "Bedroom with two windows and carpet, opening to another room.",
        "public_id": "019fba1e-3208-707a-a352-040ac8942245",
        "storage_key": "property/6767906449166793/019fba1e-3208-707a-a352-040ac8942245.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "This bedroom features two large windows with blinds, plush carpeting, and an opening to an adjacent room, offering a spacious and inviting atmosphere.",
      "link": "",
      "alt_text": "Bedroom with two windows and carpet, opening to another room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_279410f2-57d2-4850-9831-397701021db1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-31a3-732c-abb8-0ffcc7fa7090.webp",
      "image_media": {
        "alt_text": "Bathroom vanity, toilet, and in-unit washer and dryer.",
        "public_id": "019fba1e-31a3-732c-abb8-0ffcc7fa7090",
        "storage_key": "property/6767906449166793/019fba1e-31a3-732c-abb8-0ffcc7fa7090.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of a private bathroom with a modern vanity and an in-unit washer and dryer.",
      "link": "",
      "alt_text": "Bathroom vanity, toilet, and in-unit washer and dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0bc05070-99cc-4717-a659-e316df6f4583",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-1e2f-7329-87b7-b9ab3a794b2c.webp",
      "image_media": {
        "alt_text": "Comfortable theater seating arranged in rows facing a large projector screen in a community movie room.",
        "public_id": "019fba1e-1e2f-7329-87b7-b9ab3a794b2c",
        "storage_key": "property/6767906449166793/019fba1e-1e2f-7329-87b7-b9ab3a794b2c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy movie nights in our on-site theater, complete with plush seating and a large screen for an immersive viewing experience.",
      "link": "",
      "alt_text": "Comfortable theater seating arranged in rows facing a large projector screen in a community movie room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f4022076-024f-4523-aed5-920e240cded5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-1bf1-70f6-94f0-46f88284f9ec.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel appliances, and a microwave.",
        "public_id": "019fba1e-1bf1-70f6-94f0-46f88284f9ec",
        "storage_key": "property/6767906449166793/019fba1e-1bf1-70f6-94f0-46f88284f9ec.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring granite countertops, stainless steel appliances, a microwave, and a decorative backsplash.",
      "link": "",
      "alt_text": "Kitchen with granite countertops, stainless steel appliances, and a microwave.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8cddaa0e-4847-4b32-a900-4fe1ea813be1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-1676-703e-aacd-adb0477568dc.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with courtyards and landscaping.",
        "public_id": "019fba1e-1676-703e-aacd-adb0477568dc",
        "storage_key": "property/6767906449166793/019fba1e-1676-703e-aacd-adb0477568dc.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover our beautiful apartment community, featuring well-maintained courtyards and attractive building exteriors, offering a comfortable living environment.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with courtyards and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1704a66c-31a4-4d44-9acb-50c38674fbb3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-126f-7073-997d-915486e457f7.webp",
      "image_media": {
        "alt_text": "Community club room with a full-service bar and high-top seating.",
        "public_id": "019fba1e-126f-7073-997d-915486e457f7",
        "storage_key": "property/6767906449166793/019fba1e-126f-7073-997d-915486e457f7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy socializing at our community club room, featuring a beautifully designed bar area with ample seating for residents and guests.",
      "link": "",
      "alt_text": "Community club room with a full-service bar and high-top seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4f56b49d-9e6d-4acf-99f3-0437b3e18d48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-0c87-71e2-8c4e-f71ad75843ea.webp",
      "image_media": {
        "alt_text": "Open-concept kitchen and living area with island and dining table.",
        "public_id": "019fba1e-0c87-71e2-8c4e-f71ad75843ea",
        "storage_key": "property/6767906449166793/019fba1e-0c87-71e2-8c4e-f71ad75843ea.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen featuring gray cabinetry, white countertops, and an island, flows into a spacious living and dining area.",
      "link": "",
      "alt_text": "Open-concept kitchen and living area with island and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_216c21e6-122a-4fd3-8d4a-489dbd007558",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-fab9-761b-9a9c-03427df0e98e.webp",
      "image_media": {
        "alt_text": "Living and dining area with a sofa, chairs, dining table, and fireplace.",
        "public_id": "019fba1d-fab9-761b-9a9c-03427df0e98e",
        "storage_key": "property/6767906449166793/019fba1d-fab9-761b-9a9c-03427df0e98e.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable sofa, accent chairs, a dining table for six, and a stone fireplace. Large windows provide ample natural light.",
      "link": "",
      "alt_text": "Living and dining area with a sofa, chairs, dining table, and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b3a6c014-c353-4e60-8555-6f67b9e8a293",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-00f2-761f-9819-6aa07937251f.webp",
      "image_media": {
        "alt_text": "Exterior of a modern multifamily building with a three-car garage and landscaping.",
        "public_id": "019fba1e-00f2-761f-9819-6aa07937251f",
        "storage_key": "property/6767906449166793/019fba1e-00f2-761f-9819-6aa07937251f.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Stunning modern multifamily building featuring a spacious three-car garage, elegant stone accents, and lush landscaping.",
      "link": "",
      "alt_text": "Exterior of a modern multifamily building with a three-car garage and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ec29b3f3-78a1-498b-b0bf-4c6d768843e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-f7d3-77fb-abb2-023f4857f12e.webp",
      "image_media": {
        "alt_text": "Empty living room with carpet, neutral gray walls, and sliding glass doors leading to a balcony.",
        "public_id": "019fba1d-f7d3-77fb-abb2-023f4857f12e",
        "storage_key": "property/6767906449166793/019fba1d-f7d3-77fb-abb2-023f4857f12e.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting and a private balcony, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Empty living room with carpet, neutral gray walls, and sliding glass doors leading to a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a5f0ac34-6046-41d9-b7e0-73cc393064d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-f757-7238-b66e-875f3ad35911.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, weight machines, and dumbbells, overlooking an exterior view.",
        "public_id": "019fba1d-f757-7238-b66e-875f3ad35911",
        "storage_key": "property/6767906449166793/019fba1d-f757-7238-b66e-875f3ad35911.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, weight training equipment, and free weights.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, weight machines, and dumbbells, overlooking an exterior view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_352f7e25-282f-4c2d-b936-09cbaf6f22dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-ed49-74f0-b938-36b42c71e43f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets and granite countertops.",
        "public_id": "019fba1d-ed49-74f0-b938-36b42c71e43f",
        "storage_key": "property/6767906449166793/019fba1d-ed49-74f0-b938-36b42c71e43f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore this modern apartment kitchen featuring sleek gray cabinetry, granite countertops, and stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_95671d7f-490c-479a-b8a3-733940755432",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-e9d2-75a5-adae-3e7b970a9809.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelves and hanging rods.",
        "public_id": "019fba1d-e9d2-75a5-adae-3e7b970a9809",
        "storage_key": "property/6767906449166793/019fba1d-e9d2-75a5-adae-3e7b970a9809.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with shelves and hanging rods.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6285e4fd-380d-4e49-b8b0-5cc575248418",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-e802-741c-9647-6d7fd1910367.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property's exterior with buildings, landscaping, and parking areas.",
        "public_id": "019fba1d-e802-741c-9647-6d7fd1910367",
        "storage_key": "property/6767906449166793/019fba1d-e802-741c-9647-6d7fd1910367.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Aerial view showcasing the exterior of the multifamily property, highlighting its buildings, manicured landscaping, and convenient parking facilities.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property's exterior with buildings, landscaping, and parking areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb384151-e7eb-4e62-8a39-e6cc2f2b4fb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-d29d-768e-92bc-d28b7e4da986.webp",
      "image_media": {
        "alt_text": "Community room with tables and chairs",
        "public_id": "019fba1d-d29d-768e-92bc-d28b7e4da986",
        "storage_key": "property/6767906449166793/019fba1d-d29d-768e-92bc-d28b7e4da986.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and socialize in our comfortable community room, featuring ample seating and natural light.",
      "link": "",
      "alt_text": "Community room with tables and chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_da6d8f38-d98b-48bd-9e76-950db7910bae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-d580-73ff-bf80-b1780a07a604.webp",
      "image_media": {
        "alt_text": "Covered outdoor seating area with tables and chairs.",
        "public_id": "019fba1d-d580-73ff-bf80-b1780a07a604",
        "storage_key": "property/6767906449166793/019fba1d-d580-73ff-bf80-b1780a07a604.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Enjoy ample outdoor seating with tables and chairs on this covered patio, perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Covered outdoor seating area with tables and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ccc40e01-b2c3-4c22-89d4-77f55ef2a5e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-ceca-72ef-b33f-3c405e4a676a.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet, a window with blinds, and a door.",
        "public_id": "019fba1d-ceca-72ef-b33f-3c405e4a676a",
        "storage_key": "property/6767906449166793/019fba1d-ceca-72ef-b33f-3c405e4a676a.webp",
        "width": 3072,
        "height": 2056
      },
      "title": "Apartment",
      "description": "Spacious bedroom with neutral tones and ample natural light. Perfect for creating your personal sanctuary.",
      "link": "",
      "alt_text": "Empty bedroom with carpet, a window with blinds, and a door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_742bbf51-f6a2-42dd-8963-069810b5b7df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-cf34-765c-9ef9-4b7703acf079.webp",
      "image_media": {
        "alt_text": "Kitchen with gray cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fba1d-cf34-765c-9ef9-4b7703acf079",
        "storage_key": "property/6767906449166793/019fba1d-cf34-765c-9ef9-4b7703acf079.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring sleek gray cabinetry, durable granite countertops, and a full suite of stainless steel appliances. Perfect for any home chef.",
      "link": "",
      "alt_text": "Kitchen with gray cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_907c3a96-3aac-4f32-b563-ebec55822c7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-d5c3-72ca-a818-40935a96ed97.webp",
      "image_media": {
        "alt_text": "View of a room with hardwood floors and blinds on the window. Double doors open to another room.",
        "public_id": "019fba1d-d5c3-72ca-a818-40935a96ed97",
        "storage_key": "property/6767906449166793/019fba1d-d5c3-72ca-a818-40935a96ed97.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This spacious room features elegant hardwood flooring and large windows with blinds. Double doors lead to an adjoining living area, offering an open and inviting feel.",
      "link": "",
      "alt_text": "View of a room with hardwood floors and blinds on the window. Double doors open to another room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80e03c05-9312-47e0-8203-3ba20c5954fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-c8fa-756d-b1bd-5986ea30174e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island.",
        "public_id": "019fba1d-c8fa-756d-b1bd-5986ea30174e",
        "storage_key": "property/6767906449166793/019fba1d-c8fa-756d-b1bd-5986ea30174e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and a large central island perfect for meal preparation and casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_68bef250-10ee-49dd-9c93-7f3822ec2595",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-bb7e-765d-8f8b-36e6d3b46183.webp",
      "image_media": {
        "alt_text": "Comfortable seating area in the community lounge with a sofa, armchairs, coffee table, and artwork.",
        "public_id": "019fba1d-bb7e-765d-8f8b-36e6d3b46183",
        "storage_key": "property/6767906449166793/019fba1d-bb7e-765d-8f8b-36e6d3b46183.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring comfortable seating and tasteful decor.",
      "link": "",
      "alt_text": "Comfortable seating area in the community lounge with a sofa, armchairs, coffee table, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9cf4f0e9-8c10-4ff8-b3aa-9d8ef347b343",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-b65b-72f0-ae3b-2d140fdbe340.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with two yellow armchairs, a dark gray sofa, and a wooden coffee table.",
        "public_id": "019fba1d-b65b-72f0-ae3b-2d140fdbe340",
        "storage_key": "property/6767906449166793/019fba1d-b65b-72f0-ae3b-2d140fdbe340.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in the stylish lounge area, featuring plush seating and vibrant artwork. A perfect spot to gather with friends or enjoy a quiet moment.",
      "link": "",
      "alt_text": "Comfortable seating area with two yellow armchairs, a dark gray sofa, and a wooden coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0a88ee80-6821-48d7-b0d7-2b16eb3193b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-b0aa-7699-9b1a-b3314e045e9b.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, sink, large mirror, and a floral shower curtain.",
        "public_id": "019fba1d-b0aa-7699-9b1a-b3314e045e9b",
        "storage_key": "property/6767906449166793/019fba1d-b0aa-7699-9b1a-b3314e045e9b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into a clean and modern bathroom featuring a sleek white vanity, a spacious sink, and a decorative floral shower curtain for a touch of elegance.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, sink, large mirror, and a floral shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eb3d957c-269d-4b26-b740-1e7064dd8f8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-abb5-708f-adea-93837997375a.webp",
      "image_media": {
        "alt_text": "Community room with a Scrabble board, bar stools, and built-in shelving.",
        "public_id": "019fba1d-abb5-708f-adea-93837997375a",
        "storage_key": "property/6767906449166793/019fba1d-abb5-708f-adea-93837997375a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy leisure time in the community room, featuring a Scrabble board, comfortable seating, and elegant built-in shelving for decorative items and plants.",
      "link": "",
      "alt_text": "Community room with a Scrabble board, bar stools, and built-in shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c9e3fe51-fde7-4b31-9a40-771d55532782",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-a8f7-7245-ab77-d52f03bc2d72.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with surrounding homes and distant city skyline.",
        "public_id": "019fba1d-a8f7-7245-ab77-d52f03bc2d72",
        "storage_key": "property/6767906449166793/019fba1d-a8f7-7245-ab77-d52f03bc2d72.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "An aerial perspective showcases this multifamily property nestled within a suburban landscape, offering a glimpse of its community amenities and surrounding neighborhood.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property with surrounding homes and distant city skyline.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6a74d16c-0b1b-4eaa-8546-67908852d41b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-a733-76dc-816f-a7592d8af976.webp",
      "image_media": {
        "alt_text": "Modern home office with L-shaped desk, ergonomic chair, printer, and large wardrobe.",
        "public_id": "019fba1d-a733-76dc-816f-a7592d8af976",
        "storage_key": "property/6767906449166793/019fba1d-a733-76dc-816f-a7592d8af976.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Create your ideal work-from-home setup in this spacious and well-lit home office, featuring a large L-shaped desk, ample storage, and a comfortable chair.",
      "link": "",
      "alt_text": "Modern home office with L-shaped desk, ergonomic chair, printer, and large wardrobe.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2f4051ee-2a1b-4dfd-ae7f-44ad072568d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-8bd8-70cb-8479-6d394e9945f6.webp",
      "image_media": {
        "alt_text": "Grand piano in a common area with large windows and seating.",
        "public_id": "019fba1d-8bd8-70cb-8479-6d394e9945f6",
        "storage_key": "property/6767906449166793/019fba1d-8bd8-70cb-8479-6d394e9945f6.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy the amenities of our community, including a grand piano for residents to enjoy in our common lounge area.",
      "link": "",
      "alt_text": "Grand piano in a common area with large windows and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b9803a69-fe1e-4adc-b626-c829ba00938f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-9958-71f7-a6c0-d17890f8544f.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with covered entrance at sunset.",
        "public_id": "019fba1d-9958-71f7-a6c0-d17890f8544f",
        "storage_key": "property/6767906449166793/019fba1d-9958-71f7-a6c0-d17890f8544f.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Beautiful sunset over the apartment complex, highlighting the welcoming entrance and exterior architecture.",
      "link": "",
      "alt_text": "Exterior of apartment building with covered entrance at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eeaa80ff-5edc-4fd4-b878-8e31be5432fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-85f9-73eb-b895-064085f01f8a.webp",
      "image_media": {
        "alt_text": "Community game room with bookshelves, tables, and chairs.",
        "public_id": "019fba1d-85f9-73eb-b895-064085f01f8a",
        "storage_key": "property/6767906449166793/019fba1d-85f9-73eb-b895-064085f01f8a.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy board games and puzzles in our community game room, featuring ample shelving and comfortable seating.",
      "link": "",
      "alt_text": "Community game room with bookshelves, tables, and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_67687e9d-3f9b-4143-a997-b24bd1d03e94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-8847-728a-8ce1-e6593c278b02.webp",
      "image_media": {
        "alt_text": "Hallway with wood-look flooring and doors to rooms. Includes a visible bathroom.",
        "public_id": "019fba1d-8847-728a-8ce1-e6593c278b02",
        "storage_key": "property/6767906449166793/019fba1d-8847-728a-8ce1-e6593c278b02.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Explore the spacious hallway of this apartment, featuring elegant wood-look flooring and convenient access to various living spaces, including a well-appointed bathroom.",
      "link": "",
      "alt_text": "Hallway with wood-look flooring and doors to rooms. Includes a visible bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_63ba68cd-1fb5-4777-be10-920fc5435e43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-863f-7414-9476-98c37bb031fc.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with seating and tables, surrounded by landscaping and buildings.",
        "public_id": "019fba1d-863f-7414-9476-98c37bb031fc",
        "storage_key": "property/6767906449166793/019fba1d-863f-7414-9476-98c37bb031fc.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy outdoor living and entertaining in our beautifully landscaped community spaces. Relax on the patio with comfortable seating and tables.",
      "link": "",
      "alt_text": "Outdoor patio area with seating and tables, surrounded by landscaping and buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_acc19e58-5c41-4443-89f3-2f04e36ace93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-90ff-70f8-8db3-388b3a3cab4f.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, oak cabinets, and light gray countertops.",
        "public_id": "019fba1d-90ff-70f8-8db3-388b3a3cab4f",
        "storage_key": "property/6767906449166793/019fba1d-90ff-70f8-8db3-388b3a3cab4f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring white appliances, ample oak cabinetry, and durable light gray countertops, perfect for everyday cooking.",
      "link": "",
      "alt_text": "Kitchen with white appliances, oak cabinets, and light gray countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_efdc7bb9-99e2-47c2-8c9e-b25fcdecaa35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-8c21-771e-81e3-90875a7cac41.webp",
      "image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and large windows.",
        "public_id": "019fba1d-8c21-771e-81e3-90875a7cac41",
        "storage_key": "property/6767906449166793/019fba1d-8c21-771e-81e3-90875a7cac41.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy leisure time in our community lounge, featuring a pool table and comfortable seating areas, perfect for socializing and relaxation.",
      "link": "",
      "alt_text": "Community lounge area with a pool table, seating, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0b99a5d4-9afb-49ba-9638-4de6dba2b818",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-712f-732d-82ca-91bdc4c8df22.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and large windows.",
        "public_id": "019fba1d-712f-732d-82ca-91bdc4c8df22",
        "storage_key": "property/6767906449166793/019fba1d-712f-732d-82ca-91bdc4c8df22.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a stone fireplace, comfortable seating, and ample natural light from large windows.",
      "link": "",
      "alt_text": "Living room with fireplace and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_343bbaa7-c8c7-466f-90a0-dddde49bb9e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-6cda-7118-99f0-771e73e75757.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and white countertops.",
        "public_id": "019fba1d-6cda-7118-99f0-771e73e75757",
        "storage_key": "property/6767906449166793/019fba1d-6cda-7118-99f0-771e73e75757.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Discover a beautifully designed kitchen featuring a spacious island, sleek stainless steel appliances, ample cabinet storage, and elegant white countertops, perfect for any culinary enthusiast.",
      "link": "",
      "alt_text": "Modern kitchen with island, stainless steel appliances, and white countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2e48861a-b5a6-4e27-9fe2-14617a55c217",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-6250-73d9-815e-7f340ed9ae02.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet, window, and door",
        "public_id": "019fba1d-6250-73d9-815e-7f340ed9ae02",
        "storage_key": "property/6767906449166793/019fba1d-6250-73d9-815e-7f340ed9ae02.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom with neutral carpeting, large window, and ample wall space, ready for your personal touch.",
      "link": "",
      "alt_text": "Empty bedroom with carpet, window, and door",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_201bb7b1-643b-421a-a405-c1663e91bc8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-5e46-7680-b8cd-df8360220d6f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet with grab bars, and a glass-enclosed shower.",
        "public_id": "019fba1d-5e46-7680-b8cd-df8360220d6f",
        "storage_key": "property/6767906449166793/019fba1d-5e46-7680-b8cd-df8360220d6f.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Step into this clean and accessible bathroom, featuring a sleek vanity, a comfortable toilet with grab bars, and a spacious glass-enclosed shower for a refreshing experience.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, toilet with grab bars, and a glass-enclosed shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_96973c67-7c4d-4900-9775-f224e2e17b05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-5c8c-7532-9f37-9916fc1ba3f3.webp",
      "image_media": {
        "alt_text": "Exterior of a modern home with a three-car garage, stone accents, and a covered entryway.",
        "public_id": "019fba1d-5c8c-7532-9f37-9916fc1ba3f3",
        "storage_key": "property/6767906449166793/019fba1d-5c8c-7532-9f37-9916fc1ba3f3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Charming home exterior featuring a spacious three-car garage and a welcoming covered entryway with modern stone accents.",
      "link": "",
      "alt_text": "Exterior of a modern home with a three-car garage, stone accents, and a covered entryway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_11bfbf32-fb71-409d-8b63-70feac0875b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-4ad9-76ab-b29e-0b720d0617ce.webp",
      "image_media": {
        "alt_text": "Aerial view of a sprawling multifamily property with various buildings, green spaces, and distant mountains.",
        "public_id": "019fba1d-4ad9-76ab-b29e-0b720d0617ce",
        "storage_key": "property/6767906449166793/019fba1d-4ad9-76ab-b29e-0b720d0617ce.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "An expansive aerial view showcases the diverse architecture and landscaping of this multifamily community, set against a backdrop of distant mountains and a clear blue sky.",
      "link": "",
      "alt_text": "Aerial view of a sprawling multifamily property with various buildings, green spaces, and distant mountains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2e1bb4ff-68dc-40d0-9935-20640172d214",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-5ceb-709a-be09-063e929d9658.webp",
      "image_media": {
        "alt_text": "Empty closet with shelving and hanging rods.",
        "public_id": "019fba1d-5ceb-709a-be09-063e929d9658",
        "storage_key": "property/6767906449166793/019fba1d-5ceb-709a-be09-063e929d9658.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious closet with built-in shelving and hanging rods, ready for your storage needs.",
      "link": "",
      "alt_text": "Empty closet with shelving and hanging rods.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_671aaf31-e800-40c1-96eb-f0e4acb52897",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-55e8-75be-85df-ffa5dab22f36.webp",
      "image_media": {
        "alt_text": "Living room with a loveseat, ottoman, accent chair, and artwork.",
        "public_id": "019fba1d-55e8-75be-85df-ffa5dab22f36",
        "storage_key": "property/6767906449166793/019fba1d-55e8-75be-85df-ffa5dab22f36.webp",
        "width": 3072,
        "height": 2054
      },
      "title": "Apartment",
      "description": "Comfortable and stylish living room featuring a loveseat with ottoman, a plush accent chair, and decorative artwork on the wall. Large windows provide natural light.",
      "link": "",
      "alt_text": "Living room with a loveseat, ottoman, accent chair, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b4522bed-8fe4-479b-ba25-83bee19161c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-4ba5-77f9-aa6a-c6abc81a2634.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a tile backsplash.",
        "public_id": "019fba1d-4ba5-77f9-aa6a-c6abc81a2634",
        "storage_key": "property/6767906449166793/019fba1d-4ba5-77f9-aa6a-c6abc81a2634.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this beautifully updated kitchen, featuring elegant granite countertops, gleaming stainless steel appliances, and a stylish tile backsplash. Perfect for culinary adventures.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0b683590-6dac-4d9a-b5a6-65a29bcb11ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-3951-761a-a800-23b734cfefdb.webp",
      "image_media": {
        "alt_text": "Modern community lounge with black leather sofas facing a stone fireplace and wooden coffee table.",
        "public_id": "019fba1d-3951-761a-a800-23b734cfefdb",
        "storage_key": "property/6767906449166793/019fba1d-3951-761a-a800-23b734cfefdb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, a cozy fireplace, and elegant decor.",
      "link": "",
      "alt_text": "Modern community lounge with black leather sofas facing a stone fireplace and wooden coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_19824c53-0582-491b-a3b6-cdce84ed1456",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-51de-7674-ad4d-f41cf9257a8d.webp",
      "image_media": {
        "alt_text": "Property entrance with covered porte-cochere and American flag.",
        "public_id": "019fba1d-51de-7674-ad4d-f41cf9257a8d",
        "storage_key": "property/6767906449166793/019fba1d-51de-7674-ad4d-f41cf9257a8d.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Welcome to the property entrance, featuring a covered porte-cochere, ample parking, and a patriotic American flag, set against a backdrop of lush trees and a clear blue sky.",
      "link": "",
      "alt_text": "Property entrance with covered porte-cochere and American flag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ad8b1f5f-cc08-41c1-bd90-f238a653512a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-3819-7765-8d77-5716e9a94e33.webp",
      "image_media": {
        "alt_text": "Master bedroom with king-size bed, vanity, and access to balcony",
        "public_id": "019fba1d-3819-7765-8d77-5716e9a94e33",
        "storage_key": "property/6767906449166793/019fba1d-3819-7765-8d77-5716e9a94e33.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious master bedroom featuring a comfortable king-size bed, elegant vanity, and direct access to a private balcony.",
      "link": "",
      "alt_text": "Master bedroom with king-size bed, vanity, and access to balcony",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3784e832-c549-4699-812e-7e4b0a3b41eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-39b8-765a-8c74-8dfff62803ae.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a large walk-in shower featuring grab bars and a glass door.",
        "public_id": "019fba1d-39b8-765a-8c74-8dfff62803ae",
        "storage_key": "property/6767906449166793/019fba1d-39b8-765a-8c74-8dfff62803ae.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Step into comfort and accessibility with this spacious walk-in shower, complete with convenient grab bars for enhanced safety and a sleek glass enclosure.",
      "link": "",
      "alt_text": "Modern bathroom with a large walk-in shower featuring grab bars and a glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29e80c52-ef4c-4304-96f8-e196967c3c57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-3878-7346-ab26-ee1ba441a83d.webp",
      "image_media": {
        "alt_text": "Laundry room with white washer and dryer, white cabinets, and a closed door.",
        "public_id": "019fba1d-3878-7346-ab26-ee1ba441a83d",
        "storage_key": "property/6767906449166793/019fba1d-3878-7346-ab26-ee1ba441a83d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry area featuring a stacked washer and dryer, ample storage with overhead cabinets, and a neutral color palette.",
      "link": "",
      "alt_text": "Laundry room with white washer and dryer, white cabinets, and a closed door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ff57773c-6f9b-4365-a8f3-8a13eb71a08c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-265a-76f9-8d22-7e371e7957b4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
        "public_id": "019fba1d-265a-76f9-8d22-7e371e7957b4",
        "storage_key": "property/6767906449166793/019fba1d-265a-76f9-8d22-7e371e7957b4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring granite countertops, stainless steel appliances, ample cabinet space, and a convenient breakfast bar for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8f88a9fd-ed5c-4d3b-ae04-37b70bba7179",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-2032-75dd-8c08-e30559cb45e4.webp",
      "image_media": {
        "alt_text": "Bathroom with shower, toilet, sink, and vanity.",
        "public_id": "019fba1d-2032-75dd-8c08-e30559cb45e4",
        "storage_key": "property/6767906449166793/019fba1d-2032-75dd-8c08-e30559cb45e4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a walk-in shower with grab bars, a toilet with additional support, and a vanity with ample counter space.",
      "link": "",
      "alt_text": "Bathroom with shower, toilet, sink, and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9c386d79-aa23-42d8-a346-88bbc501edb8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-235d-73b9-b3f0-3158395f7eb7.webp",
      "image_media": {
        "alt_text": "Accessible bathroom with toilet and roll-in shower",
        "public_id": "019fba1d-235d-73b9-b3f0-3158395f7eb7",
        "storage_key": "property/6767906449166793/019fba1d-235d-73b9-b3f0-3158395f7eb7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy convenience and accessibility in our thoughtfully designed bathrooms, featuring grab bars and a spacious roll-in shower.",
      "link": "",
      "alt_text": "Accessible bathroom with toilet and roll-in shower",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bc67951e-8df1-4c62-8273-91a1b6999958",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-231d-7719-9c51-0e20805a5242.webp",
      "image_media": {
        "alt_text": "Outdoor putting green and bocce ball court with seating and patio furniture under red umbrellas.",
        "public_id": "019fba1d-231d-7719-9c51-0e20805a5242",
        "storage_key": "property/6767906449166793/019fba1d-231d-7719-9c51-0e20805a5242.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with the community putting green and bocce ball court, perfect for socializing and leisure.",
      "link": "",
      "alt_text": "Outdoor putting green and bocce ball court with seating and patio furniture under red umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c8b34244-8b1f-42ac-93e8-da8415adb384",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Topgolf Centennial",
      "poi_type": "Restaurants",
      "poi_address": "10601 E Easter Ave, Centennial, CO 80112, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun and interactive golfing experience with a variety of games suitable for all skill levels, and serves tasty food and drinks. They also highlight the reasonable prices, lively atmosphere, and friendly, attentive service.\n\nOther reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-b32e-75e9-bad1-27047d8bf093.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-b32e-75e9-bad1-27047d8bf093",
        "storage_key": "property/6767906449166793/019d02cf-b32e-75e9-bad1-27047d8bf093.webp",
        "width": 775,
        "height": 517
      },
      "poi_business_url": "https://topgolf.com/us/centennial/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12049091762127970085&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-centennial",
      "poi_latitude": "39.5890963",
      "poi_longitude": "-104.8653656",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 720-880-3151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-fcc8-713d-b1d4-22fa3a98fb3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-fcc8-713d-b1d4-22fa3a98fb3b",
        "storage_key": "property/6767906449166793/019d02cf-fcc8-713d-b1d4-22fa3a98fb3b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBer71eCFbIcRJR-5ax75Nqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_35d267f1-2c3f-4f8f-bbe9-ed9c19d6e1e2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "ViewHouse",
      "poi_type": "Restaurants",
      "poi_address": "7101 S Clinton St, Centennial, CO 80112, USA",
      "poi_short_description": "Bustling restaurant & bar with outdoor tables offering a menu of hearty American standards.",
      "poi_long_description": "People say this bar and grill offers a delicious brunch buffet with a wide selection of seafood, sushi, and breakfast items, as well as tasty burgers, pizza, and wings. They also highlight the beautiful mountain views, the fun and lively atmosphere, and the attentive service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-b371-72ee-afa9-aa85fbebbc5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-b371-72ee-afa9-aa85fbebbc5c",
        "storage_key": "property/6767906449166793/019d02cf-b371-72ee-afa9-aa85fbebbc5c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.viewhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=90979526297967570&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "viewhouse",
      "poi_latitude": "39.587544",
      "poi_longitude": "-104.8793068",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-790-8440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-fcc1-742e-8be3-6dbf6b525be2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-fcc1-742e-8be3-6dbf6b525be2",
        "storage_key": "property/6767906449166793/019d02cf-fcc1-742e-8be3-6dbf6b525be2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs2KfuNmFbIcR0tvSqmU5QwE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_94249415-da8c-4095-b7f2-f8939152e162",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "14150 E Alameda Ave, Aurora, CO 80012, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, especially the Double Double Animal Style, and offers a secret menu. They also highlight the affordable prices, clean environment, and friendly service.\n\nSome reviews mention there can be a long drive-thru wait.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-b46a-741c-b54e-d59393957669.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-b46a-741c-b54e-d59393957669",
        "storage_key": "property/6767906449166793/019d02cf-b46a-741c-b54e-d59393957669.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.in-n-out.com/360",
      "poi_directions_map_url": "https://maps.google.com/?cid=14828867425962304576&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "39.7107311",
      "poi_longitude": "-104.8236298",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-fcc8-713d-b1d4-22fa3a98fb3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-fcc8-713d-b1d4-22fa3a98fb3b",
        "storage_key": "property/6767906449166793/019d02cf-fcc8-713d-b1d4-22fa3a98fb3b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXeOanAdjbIcRQCTYcVu4ys0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_bdf0ee48-1add-4e2a-b62d-2a64e8a7acd9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Pindustry",
      "poi_type": "Restaurants",
      "poi_address": "7939 E Arapahoe Rd, Greenwood Village, CO 80112, USA",
      "poi_short_description": "Chill venue with a bowling alley, arcade games, darts & pinball machines, plus pizza & cocktails.",
      "poi_long_description": "People say this restaurant offers a variety of activities, including bowling, arcade games, and live music, as well as a rooftop patio with scenic views. They also highlight the fun and vibrant atmosphere, and the friendly and helpful staff.\n\nOther reviews mention the pinball machines can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-b88c-7760-8c6b-6da6dfb9ed08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-b88c-7760-8c6b-6da6dfb9ed08",
        "storage_key": "property/6767906449166793/019d02cf-b88c-7760-8c6b-6da6dfb9ed08.webp",
        "width": 1000,
        "height": 714
      },
      "poi_business_url": "https://thepindustry.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6029080325094681636&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pindustry",
      "poi_latitude": "39.5963906",
      "poi_longitude": "-104.8978809",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 720-712-7467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-fcc8-713d-b1d4-22fa3a98fb3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-fcc8-713d-b1d4-22fa3a98fb3b",
        "storage_key": "property/6767906449166793/019d02cf-fcc8-713d-b1d4-22fa3a98fb3b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCYO4FT2HbIcRJKyQu5yYq1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d6e33bf2-e60d-4898-8b0d-6f9e979a0f88",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Park Meadows",
      "poi_type": "Shopping & Retail",
      "poi_address": "8401 Park Meadows Center Dr, Lone Tree, CO 80124, USA",
      "poi_short_description": "This enclosed shopping mall with over 185 retailers & restaurants offers valet parking.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including classic brands, fashion stores, and specialty shops like Nespresso, Apple, and Tesla. They highlight the clean, well-lit, and spacious layout, as well as the pleasant and vibrant atmosphere. They also like the extensive food court with diverse cuisine options and the convenient access via train and car.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-3a18-70bd-89d1-dcc44e970ba5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-3a18-70bd-89d1-dcc44e970ba5",
        "storage_key": "property/6767906449166793/019d02d0-3a18-70bd-89d1-dcc44e970ba5.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.parkmeadows.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=10526454183756168287&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "park-meadows",
      "poi_latitude": "39.562641",
      "poi_longitude": "-104.876604",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 303-792-2999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-fcc3-723c-a026-31e08aae132f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-fcc3-723c-a026-31e08aae132f",
        "storage_key": "property/6767906449166793/019d02cf-fcc3-723c-a026-31e08aae132f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo47c6KSFbIcRX_w1_056FZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6b5ce0d5-ec00-471a-a545-22692909e32d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "9800 East IKEA Way, Centennial, CO 80112, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "People say this furniture store offers a wide selection of home furnishings, including mattresses, and Swedish meatballs. They also highlight the friendly staff, clean environment, and reasonable prices.\n\nSome reviews mention the wait times for returns can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-ba58-765d-8a83-938e829c7a05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-ba58-765d-8a83-938e829c7a05",
        "storage_key": "property/6767906449166793/019d02cf-ba58-765d-8a83-938e829c7a05.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/centennial/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=centennial",
      "poi_directions_map_url": "https://maps.google.com/?cid=8387791718723325228&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "39.5719355",
      "poi_longitude": "-104.8751975",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-fcc3-723c-a026-31e08aae132f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-fcc3-723c-a026-31e08aae132f",
        "storage_key": "property/6767906449166793/019d02cf-fcc3-723c-a026-31e08aae132f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJARrMTseFbIcRLI13tCBsZ3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_d96d1f6b-d9eb-4f23-905e-d73a5a2eb764",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "H Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "2751 S Parker Rd, Aurora, CO 80014, USA",
      "poi_short_description": "Large supermarket brimming with fresh produce and international foods.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meat, seafood, and international ingredients. They also highlight the extensive selection of snacks, noodles, and sauces, and the affordable prices on produce.\n\nOther reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-be80-72f9-86b2-a85a48f98bff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-be80-72f9-86b2-a85a48f98bff",
        "storage_key": "property/6767906449166793/019d02cf-be80-72f9-86b2-a85a48f98bff.webp",
        "width": 1080,
        "height": 641
      },
      "poi_business_url": "http://www.myhmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9729704830360140207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-mart",
      "poi_latitude": "39.6659575",
      "poi_longitude": "-104.8632898",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-745-4592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-fcbd-70c5-9fe6-edd0ff5ff074.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-fcbd-70c5-9fe6-edd0ff5ff074",
        "storage_key": "property/6767906449166793/019d02cf-fcbd-70c5-9fe6-edd0ff5ff074.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDenuLPKHbIcRr7kEN_7aBoc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_b320d731-25b9-422d-8048-509e93a99e26",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Town Center at Aurora",
      "poi_type": "Shopping & Retail",
      "poi_address": "14200 E Alameda Ave, Aurora, CO 80012, USA",
      "poi_short_description": "Bustling indoor mall featuring 150-plus retailers, including big-box stores, & restaurants.",
      "poi_long_description": "People say this shopping center offers a wide selection of stores and a variety of food options. They also highlight the clean and well-maintained environment, and the availability of activities for all ages.\n\nOther reviews mention the stores can be typical.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-bed6-76a8-9938-7734bc9aac9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-bed6-76a8-9938-7734bc9aac9a",
        "storage_key": "property/6767906449166793/019d02cf-bed6-76a8-9938-7734bc9aac9a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://towncenterataurora.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3680964791751543485&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "town-center-at-aurora",
      "poi_latitude": "39.7082577",
      "poi_longitude": "-104.823209",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-344-9764",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-fcc3-723c-a026-31e08aae132f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-fcc3-723c-a026-31e08aae132f",
        "storage_key": "property/6767906449166793/019d02cf-fcc3-723c-a026-31e08aae132f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaR59v8JibIcRvQoSu_lpFTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_78450d08-5fa8-47dc-8a01-86ac8033f2b6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "7400 E Hampden Ave Unit D, Denver, CO 80231, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, high-quality meats, and unique products. They also highlight the clean and organized store, and the helpful and friendly staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-3bc6-7079-b909-94208bffa6c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-3bc6-7079-b909-94208bffa6c8",
        "storage_key": "property/6767906449166793/019d02d0-3bc6-7079-b909-94208bffa6c8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/tamarac?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=2401647277010190830&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "39.6521655",
      "poi_longitude": "-104.9019875",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 303-488-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-fcbd-70c5-9fe6-edd0ff5ff074.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cf-fcbd-70c5-9fe6-edd0ff5ff074",
        "storage_key": "property/6767906449166793/019d02cf-fcbd-70c5-9fe6-edd0ff5ff074.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEauwzXOHbIcR7gH6VXldVCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8eb17895-2bcb-478b-bf63-3685e813eb44",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Smoky Hill Library (Arapahoe Libraries)",
      "poi_type": "Education",
      "poi_address": "5430 S Biscay Cir, Centennial, CO 80015, USA",
      "poi_short_description": "Spacious, family-friendly, public library featuring a 3D printer and an enclosed children's area.",
      "poi_long_description": "People say this public library offers a cafe, a large children's section with games and toys, and rooms for events and meetings. They highlight the quiet and relaxing atmosphere, the beautiful views from the balcony, and the free activities and programs for children. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-3c5d-7799-aea1-9d11a3105fc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-3c5d-7799-aea1-9d11a3105fc3",
        "storage_key": "property/6767906449166793/019d02d0-3c5d-7799-aea1-9d11a3105fc3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://arapahoelibraries.org/locations/SM",
      "poi_directions_map_url": "https://maps.google.com/?cid=14364188005256113635&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "smoky-hill-library-arapahoe-libraries",
      "poi_latitude": "39.618139",
      "poi_longitude": "-104.7674478",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-542-7279",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-0206-72b9-924d-88b7a6bc4567.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-0206-72b9-924d-88b7a6bc4567",
        "storage_key": "property/6767906449166793/019d02d0-0206-72b9-924d-88b7a6bc4567.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEYyGs0WJbIcR46031OLYV8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_15e22d2a-ff81-4931-b738-55c3e70374a4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Boondocks Food and Fun - Parker",
      "poi_type": "Entertainment",
      "poi_address": "18706 Cottonwood Dr, Parker, CO 80138, USA",
      "poi_short_description": "Entertainment complex with a go-kart circuit, lazer tag zone & bowling alley, plus fast food.",
      "poi_long_description": "Visitors say this amusement park offers a wide variety of family-friendly activities, including go-karts, laser tag, bowling, mini golf, and bumper boats. They also highlight the friendly and helpful staff, the affordable pricing for the all-attraction pass, and the fun, exciting atmosphere.\n\nSome reviews mention the wait times for some attractions can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-3d63-7608-85e5-9036a31f3688.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-3d63-7608-85e5-9036a31f3688",
        "storage_key": "property/6767906449166793/019d02d0-3d63-7608-85e5-9036a31f3688.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://boondocks.com/parker/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3938146262332003676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "boondocks-food-and-fun---parker",
      "poi_latitude": "39.5568411",
      "poi_longitude": "-104.7725006",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 720-842-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_8AKB2eObIcRXNXUDykbpzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_a9b53883-b961-4599-ad75-cf402b4fdc74",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "15400 E Briarwood Cir, Aurora, CO 80016, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "Some visitors say this amusement park offers a wide variety of activities, including trampolines, go-karts, a zip line, and obstacle courses, and they praise the fun, clean, and well-maintained facility.\n\nOther reviews mention the staff can be unprofessional and management can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-4120-73bb-b5c8-27ffe95f3992.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-4120-73bb-b5c8-27ffe95f3992",
        "storage_key": "property/6767906449166793/019d02d0-4120-73bb-b5c8-27ffe95f3992.webp",
        "width": 1222,
        "height": 1280
      },
      "poi_business_url": "https://www.urbanair.com/colorado-aurora/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=11615554718993826956&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "39.5928623",
      "poi_longitude": "-104.8093835",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 720-466-7834",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3LbQuGPbIcRjES9nnm9MqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_c68506ef-61cc-4fb5-9e86-4e8a6c87abfd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Wings Over the Rockies Exploration of Flight (Centennial Airport)",
      "poi_type": "Entertainment",
      "poi_address": "13005 Wings Way, Centennial, CO 80112, USA",
      "poi_short_description": "Flight-focused center with immersive exhibits, simulators, and events, plus educational programs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-c679-72ac-ae07-f95d3973f1d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-c679-72ac-ae07-f95d3973f1d3",
        "storage_key": "property/6767906449166793/019d02cf-c679-72ac-ae07-f95d3973f1d3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://wingsmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2450149582669305489&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wings-over-the-rockies-exploration-of-flight-centennial-airport",
      "poi_latitude": "39.567906",
      "poi_longitude": "-104.8373447",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-360-5360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-020b-76c9-bd14-aeb8405deb93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-020b-76c9-bd14-aeb8405deb93",
        "storage_key": "property/6767906449166793/019d02d0-020b-76c9-bd14-aeb8405deb93.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__8_JIqFbIcRkVaTYRCuACI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_000bded7-7fc5-4e27-a5cb-2d2aa743b6a3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Museum of Outdoor Arts",
      "poi_type": "Entertainment",
      "poi_address": "6331 S Fiddlers Green Cir, Greenwood Village, CO 80111, USA",
      "poi_short_description": "Sophisticated venue offers modern art exhibitions, an outdoor sculpture garden & education programs.",
      "poi_long_description": "Visitors say this art museum offers a unique concert experience with bluegrass music, a sculpture garden, and a Cabinet of Curiosities. They also highlight the family-friendly atmosphere, beautiful park setting, and convenient food and beverage options, including wine and beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-c96d-7141-a972-07d717a0471e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-c96d-7141-a972-07d717a0471e",
        "storage_key": "property/6767906449166793/019d02cf-c96d-7141-a972-07d717a0471e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://moaonline.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6859190246263805300&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "museum-of-outdoor-arts",
      "poi_latitude": "39.6020522",
      "poi_longitude": "-104.8932659",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 303-806-0444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-020b-76c9-bd14-aeb8405deb93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-020b-76c9-bd14-aeb8405deb93",
        "storage_key": "property/6767906449166793/019d02d0-020b-76c9-bd14-aeb8405deb93.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJwwIeyYmGbIcRdNVg-y-9MF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d0332601-20b3-4aee-a36e-aa7d366f8334",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "5999 S Southlands Pkwy, Aurora, CO 80016, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of slides, a junior area, and activities like dodgeball and basketball. They highlight the fun and engaging experience for families and adults, and the clean and safe environment. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-cc65-70d6-83e8-bc1100d461d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-cc65-70d6-83e8-bc1100d461d0",
        "storage_key": "property/6767906449166793/019d02cf-cc65-70d6-83e8-bc1100d461d0.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/co-southlands",
      "poi_directions_map_url": "https://maps.google.com/?cid=9662438506586232327&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "39.6077994",
      "poi_longitude": "-104.7116203",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 720-706-1713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr-2QgNONbIcRB9YgwaDgF4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_281cb6db-f43a-49d6-beff-f2629afb5033",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Club Greenwood",
      "poi_type": "Health and Wellness",
      "poi_address": "5801 S Quebec St, Greenwood Village, CO 80111, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers a wide variety of fitness classes, a large weight room, and multiple pools. They also highlight the clean facilities, spacious locker rooms with amenities like a sauna and steam room, and the kind and welcoming staff.\n\nOther reviews mention the cancellation policy can be frustrating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-4456-72de-843d-a517c48f47a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-4456-72de-843d-a517c48f47a2",
        "storage_key": "property/6767906449166793/019d02d0-4456-72de-843d-a517c48f47a2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://clubgreenwood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7160767558804374953&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "club-greenwood",
      "poi_latitude": "39.610557",
      "poi_longitude": "-104.9056307",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 303-770-2582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGcQRlu2GbIcRqQWtxScoYGM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_e81154cc-6237-49ec-bf2b-752fea21fc0f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "15900 E Briarwood Cir, Aurora, CO 80016, USA",
      "poi_short_description": "Large health club offering cardio machines and weights, an indoor track, basketball courts, an outdoor pool, a sauna, a steam room and a hot tub.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and amenities, including basketball courts, pools, saunas, and steam rooms, and is open 24/7.\n\nOther reviews mention the facilities can be poorly maintained and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-460f-769d-80dd-54729c9a04a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-460f-769d-80dd-54729c9a04a2",
        "storage_key": "property/6767906449166793/019d02d0-460f-769d-80dd-54729c9a04a2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/aurora-co/parker-arapahoe-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=7812623122140735913&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "39.5900878",
      "poi_longitude": "-104.8030548",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 303-209-8545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwr3IiaPbIcRqakzJ1YDbGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_622bab90-9773-4320-90cc-2170442ae727",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "9250 Crown Crest Blvd, Parker, CO 80138, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of fitness amenities, including indoor and outdoor pools, pickleball courts, and a cold plunge spa. They also highlight the great community, helpful staff, and excellent instructors.\n\nSome reviews mention the membership rates can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-cf1d-74f9-b7c2-208b141b315c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-cf1d-74f9-b7c2-208b141b315c",
        "storage_key": "property/6767906449166793/019d02cf-cf1d-74f9-b7c2-208b141b315c.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/co/parker-aurora.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=17572822227809975391&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "39.5524644",
      "poi_longitude": "-104.7700651",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 720-842-0800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3dx12iObIcRX7yzHbY03_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0186865d-8d22-4f9d-96c9-ea13cbb2a905",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Animal Emergency & Specialty Center",
      "poi_type": "Health and Wellness",
      "poi_address": "17701 Cottonwood Dr, Parker, CO 80134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-4990-73ad-8d66-336bc164a15a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-4990-73ad-8d66-336bc164a15a",
        "storage_key": "property/6767906449166793/019d02d0-4990-73ad-8d66-336bc164a15a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.aescparker.com/?y_source=1_MjkzNDQyOTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9802360266798469061&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-emergency--specialty-center",
      "poi_latitude": "39.5582691",
      "poi_longitude": "-104.7822898",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 720-842-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkWpmWVmObIcRxQ_tPrr6CIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_099dc9f4-3d01-4468-9ee7-1750f5d9845a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "13730 E Mississippi Ave, Aurora, CO 80012, USA",
      "poi_short_description": "Fitness chain offering a variety of exercise equipment, tanning, and spa services, plus Wi-Fi.",
      "poi_long_description": "People say this gym offers a wide variety of cardio machines, weight circuits, and free weights. They also highlight the low monthly dues, clean and peaceful workout environment, and friendly staff.\n\nOther reviews mention the showers can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-4b59-7620-ac47-a068f8c59159.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-4b59-7620-ac47-a068f8c59159",
        "storage_key": "property/6767906449166793/019d02d0-4b59-7620-ac47-a068f8c59159.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/aurora-co?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=15032885228136660665&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.6951976",
      "poi_longitude": "-104.8321187",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 720-204-2322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbiuS7hibIcRuX5NpHeJn9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e477b75a-0e75-45ae-bb48-937b5b7f0a27",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "16921 E Quincy Ave, Aurora, CO 80015, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of classes, amenities, and training opportunities, and the staff is friendly and helpful.\n\nOther reviews mention the facilities can be crowded and the equipment can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-4d7e-76ef-b028-10b3115d86ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-4d7e-76ef-b028-10b3115d86ac",
        "storage_key": "property/6767906449166793/019d02d0-4d7e-76ef-b028-10b3115d86ac.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://vasafitness.com/locations/co/aurora/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=16362522759057617740&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "39.640203",
      "poi_longitude": "-104.790226",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-366-8272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJeVJ_gaJbIcRTLPfysFbE-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b0410820-5e79-48db-a09d-d9f83c8e544e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Ninja Nation - Centennial",
      "poi_type": "Health and Wellness",
      "poi_address": "8644 S Peoria St #800, Centennial, CO 80112, USA",
      "poi_short_description": "Gym featuring obstacle courses for kids and adults, with classes and birthday parties.",
      "poi_long_description": "People say this gym offers fun ninja obstacle courses and is great for birthday parties and corporate team building events. They highlight the staff is friendly, helpful, and encouraging, and the environment is safe and calm. They also like the availability of power outlets and Wi-Fi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-dae9-7448-af10-badff67dbf66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-dae9-7448-af10-badff67dbf66",
        "storage_key": "property/6767906449166793/019d02cf-dae9-7448-af10-badff67dbf66.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.centennial.ninjanation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14781207297904923456&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ninja-nation---centennial",
      "poi_latitude": "39.5604476",
      "poi_longitude": "-104.8375549",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 720-874-9024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrXd7mZ6PbIcRQNMIJ7llIc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6c5afe8f-56db-4462-8ece-176997a32ec8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "HCA HealthONE Aurora",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 S Potomac St, Aurora, CO 80012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-dae9-7448-af10-be15449afd2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-dae9-7448-af10-be15449afd2d",
        "storage_key": "property/6767906449166793/019d02cf-dae9-7448-af10-be15449afd2d.webp",
        "width": 750,
        "height": 421
      },
      "poi_business_url": "https://www.healthonecares.com/locations/aurora?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=16829720509392487303&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hca-healthone-aurora",
      "poi_latitude": "39.6899801",
      "poi_longitude": "-104.8321279",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-695-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-020e-755a-81a1-c912d9d2b220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-020e-755a-81a1-c912d9d2b220",
        "storage_key": "property/6767906449166793/019d02d0-020e-755a-81a1-c912d9d2b220.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJN50SWyNjbIcRhwNyt6Itj-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_deaad29e-3bdd-4df9-9f1e-ab4fef91fcee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "AdventHealth Parker",
      "poi_type": "Health and Wellness",
      "poi_address": "9395 Crown Crest Blvd, Parker, CO 80138, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-dbec-73e9-85d3-eb84296b1bf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-dbec-73e9-85d3-eb84296b1bf8",
        "storage_key": "property/6767906449166793/019d02cf-dbec-73e9-85d3-eb84296b1bf8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.adventhealth.com/hospital/adventhealth-parker",
      "poi_directions_map_url": "https://maps.google.com/?cid=5122770396696515305&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "adventhealth-parker",
      "poi_latitude": "39.5482517",
      "poi_longitude": "-104.7702808",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-269-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-020e-755a-81a1-c912d9d2b220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-020e-755a-81a1-c912d9d2b220",
        "storage_key": "property/6767906449166793/019d02d0-020e-755a-81a1-c912d9d2b220.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQxLy82uObIcR6ZL7wIi8F0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5dc4d3e0-d4d3-49f1-9b45-9ee39ee30ccc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Cherry Creek State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4201 S Parker Rd, Aurora, CO 80014, USA",
      "poi_short_description": "Large park around a reservoir with camping, water sports & many other outdoor leisure activities.",
      "poi_long_description": "People say this state park offers a variety of activities, including hiking, biking, fishing, boating, and camping. They highlight the beautiful scenery, the well-maintained trails, and the ample picnic areas with grills. They also like the large off-leash dog park and the opportunities to see wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-df4b-71b8-82ea-8df39a95c20d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-df4b-71b8-82ea-8df39a95c20d",
        "storage_key": "property/6767906449166793/019d02cf-df4b-71b8-82ea-8df39a95c20d.webp",
        "width": 500,
        "height": 333
      },
      "poi_business_url": "https://cpw.state.co.us/placestogo/parks/CherryCreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=8697569306435351271&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cherry-creek-state-park",
      "poi_latitude": "39.625962",
      "poi_longitude": "-104.8424778",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-690-1166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-0779-7578-be76-56c9bb1b4ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-0779-7578-be76-56c9bb1b4ba1",
        "storage_key": "property/6767906449166793/019d02d0-0779-7578-be76-56c9bb1b4ba1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJO9N8BMGIbIcR53Jr1zP5s3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_bae230b9-da15-4747-afe0-319ae498ceea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Kennedy Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10500 E Hampden Ave, Denver, CO 80014, USA",
      "poi_short_description": "Family orientated 27-hole, 9 hole & putting golf courses plus a restaurant, snack bar & pro shop.",
      "poi_long_description": "People say this golf course offers a variety of courses, including a par 3, and is well-maintained. They also highlight the friendly staff and good value.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-e109-776b-8d75-5cde812d9205.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-e109-776b-8d75-5cde812d9205",
        "storage_key": "property/6767906449166793/019d02cf-e109-776b-8d75-5cde812d9205.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofdenvergolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9406824941448391057&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kennedy-golf-course",
      "poi_latitude": "39.6513557",
      "poi_longitude": "-104.8671466",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 720-865-0720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-078f-7348-bd6c-696ebb24b7dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-078f-7348-bd6c-696ebb24b7dc",
        "storage_key": "property/6767906449166793/019d02d0-078f-7348-bd6c-696ebb24b7dc.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJMWx6McCHbIcRkelQ23HBi4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_80f4870d-90bd-4b24-9542-2438a8b9c48d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Cherry Creek ​Dog Of​f Leash Area (DOLA)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "S Entrance Rd, Aurora, CO 80015, USA",
      "poi_short_description": "Fenced, off-leash dog zone along a creek on 107-acres with open fields & a trail, for pass holders.",
      "poi_long_description": "People say this dog park offers a creek for dogs to swim and cool off, as well as trails for walking and open space for running. They highlight the spaciousness, the natural beauty of the river and surrounding area, and the availability of shade. They also like the dog agility equipment and the overall fun and exercise opportunities for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-542b-71d9-b05f-1fbf61c51eba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-542b-71d9-b05f-1fbf61c51eba",
        "storage_key": "property/6767906449166793/019d02d0-542b-71d9-b05f-1fbf61c51eba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cpw.state.co.us/placestogo/parks/CherryCreek/Pages/DogOff-LeashArea.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=7298849953249958272&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cherry-creek-dog-off-leash-area-dola",
      "poi_latitude": "39.6156698",
      "poi_longitude": "-104.8227513",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 303-690-1166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-0779-7578-be76-56c9bb1b4ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-0779-7578-be76-56c9bb1b4ba1",
        "storage_key": "property/6767906449166793/019d02d0-0779-7578-be76-56c9bb1b4ba1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo49ZAsSIbIcRgBlXjFy5SmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_c06cd88a-54ec-4a26-8e76-edb649acdb8d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Centennial Center Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13050 E Peakview Ave, Centennial, CO 80112, USA",
      "poi_short_description": "11-acre city park with a kids' water playground, nature areas & an amphitheater.",
      "poi_long_description": "People say this park offers a great playground with unique equipment, a splash pad, and walking paths. They highlight the fun activities for kids of all ages, the clean restrooms, and the peaceful atmosphere. They also like the ample parking and the availability of picnic tables, BBQ grills, and fireplaces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-e2c8-711c-8ece-51860fde3eff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-e2c8-711c-8ece-51860fde3eff",
        "storage_key": "property/6767906449166793/019d02cf-e2c8-711c-8ece-51860fde3eff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.centennialco.gov/Government/Departments/Parks-Trails-Open-Spaces/City-Parks-Trails/Centennial-Center-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7853175908079010446&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "centennial-center-park",
      "poi_latitude": "39.5965385",
      "poi_longitude": "-104.8374023",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-325-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-0779-7578-be76-56c9bb1b4ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-0779-7578-be76-56c9bb1b4ba1",
        "storage_key": "property/6767906449166793/019d02d0-0779-7578-be76-56c9bb1b4ba1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo7xD16yIbIcRjoK0Z-EV_Gw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_14bcca57-09e0-444d-85d0-13164f96248c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "James A. Bible Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6802 E Yale Ave, Denver, CO 80224, USA",
      "poi_short_description": "City park offering jogging trails, athletic fields & courts, a creek & a play area with a sandbox.",
      "poi_long_description": "People say this park offers a playground, tennis courts, basketball courts, and walking trails. They highlight the large, clean green spaces, picnic tables, and restrooms. They also like the dog-friendly atmosphere and ample parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-549e-741b-9cba-db93fe6c9126.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-549e-741b-9cba-db93fe6c9126",
        "storage_key": "property/6767906449166793/019d02d0-549e-741b-9cba-db93fe6c9126.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.denvergov.org/content/denvergov/en/denver-parks-and-recreation/parks/find-a-park.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8125883886751997830&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "james-a-bible-park",
      "poi_latitude": "39.6655774",
      "poi_longitude": "-104.9071721",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 720-913-1311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-0779-7578-be76-56c9bb1b4ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-0779-7578-be76-56c9bb1b4ba1",
        "storage_key": "property/6767906449166793/019d02d0-0779-7578-be76-56c9bb1b4ba1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNTcLnGOHbIcRhl_sm1fwxHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c32a993b-d4be-4670-8183-6720a112d34f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Centennial Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7565 S Peoria St, Englewood, CO 80112, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this airport offers a go-kart race track, plane and helicopter rentals, and flight schools. They also highlight the amazing food and service at the restaurant, and the opportunity to watch planes take off and land.\n\nOther reviews mention the airport can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-e754-759d-9473-77008ab665c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-e754-759d-9473-77008ab665c0",
        "storage_key": "property/6767906449166793/019d02cf-e754-759d-9473-77008ab665c0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.centennialairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15894098791119263840&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "centennial-airport",
      "poi_latitude": "39.5795225",
      "poi_longitude": "-104.8462922",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 303-790-0598",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-07bf-736a-8e47-bba0dd24550d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-07bf-736a-8e47-bba0dd24550d",
        "storage_key": "property/6767906449166793/019d02d0-07bf-736a-8e47-bba0dd24550d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_5DF-F-PbIcRYBih1aMuk9w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_0744ba56-a94c-45c9-be6f-60b86bd842b9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Belleview Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Denver, CO 80237, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-55e4-74ef-bfd3-a73bfbb68951.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-55e4-74ef-bfd3-a73bfbb68951",
        "storage_key": "property/6767906449166793/019d02d0-55e4-74ef-bfd3-a73bfbb68951.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rtd-denver.com/belleview-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=411848644852892074&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "belleview-station",
      "poi_latitude": "39.6276318",
      "poi_longitude": "-104.9044568",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 303-299-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc2LMpeKGbIcRqsGuESkutwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_b118528f-add8-40c6-afc1-55982d710b16",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Arapahoe at Village Center Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Greenwood Village, CO 80111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-56f1-7615-a3ef-f9c6e3a0aced.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-56f1-7615-a3ef-f9c6e3a0aced",
        "storage_key": "property/6767906449166793/019d02d0-56f1-7615-a3ef-f9c6e3a0aced.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rtd-denver.com/arapahoe-village-center-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=11504924654030407124&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arapahoe-at-village-center-station",
      "poi_latitude": "39.6002733",
      "poi_longitude": "-104.8885044",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-299-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwWZRJWOGbIcR1MUdYwS0qZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_fee10a97-515c-418b-ba2a-6e58896c89e6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Southmoor Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Denver, CO 80237, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-5b2a-74d9-ae81-f9ff93af8d4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-5b2a-74d9-ae81-f9ff93af8d4b",
        "storage_key": "property/6767906449166793/019d02d0-5b2a-74d9-ae81-f9ff93af8d4b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rtd-denver.com/southmoor-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=12769165996017126286&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southmoor-station",
      "poi_latitude": "39.648582",
      "poi_longitude": "-104.916267",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-299-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqdYmMECHbIcRjguZxtEwNbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_4737c957-5816-480e-a218-da2f15a50a41",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "County Line Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Lone Tree, CO 80124, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-edfb-75ab-9996-6692592406fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-edfb-75ab-9996-6692592406fa",
        "storage_key": "property/6767906449166793/019d02cf-edfb-75ab-9996-6692592406fa.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://www.rtd-denver.com/county-line-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=12999773618335282179&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "county-line-station",
      "poi_latitude": "39.562029",
      "poi_longitude": "-104.8722899",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 303-299-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcRCo0byFbIcRA3Re6Tp5aLQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_296e071f-f9b8-4427-a4f4-66bc222fbf1f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Spectrum Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6360 S Fiddlers Green Cir, Greenwood Village, CO 80111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5264694896086779453&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "spectrum-plaza",
      "poi_latitude": "39.6020823",
      "poi_longitude": "-104.8902509",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsRbW3juHbIcRPYYQTB30D0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b487721b-17d1-48b3-81d8-0fa1e1ba9b63",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Arrow Electronics Panorama",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9151 E Panorama Cir, Centennial, CO 80112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.arrow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12590639283718182594&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arrow-electronics-panorama",
      "poi_latitude": "39.5799363",
      "poi_longitude": "-104.8821225",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-824-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ52Kt3c-FbIcRwtYZcbjvuq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cf52da3f-03ec-4abb-941b-5f928b1b727b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "ULA - Einstein Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7630 S Chester St, Centennial, CO 80112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-f22f-7086-b2f9-fff6b1be9f7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-f22f-7086-b2f9-fff6b1be9f7e",
        "storage_key": "property/6767906449166793/019d02cf-f22f-7086-b2f9-fff6b1be9f7e.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16029348531149282524&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ula---einstein-building",
      "poi_latitude": "39.5783767",
      "poi_longitude": "-104.8800125",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz_Awg8-FbIcR3BwV3I-vc94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_39ce9d73-d155-435d-8410-d953a8903286",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "United Launch Alliance",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9501 E Panorama Cir, Centennial, CO 80112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-5dc7-77c9-bd4a-137767e2fdee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-5dc7-77c9-bd4a-137767e2fdee",
        "storage_key": "property/6767906449166793/019d02d0-5dc7-77c9-bd4a-137767e2fdee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ulalaunch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5824619751057825106&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "united-launch-alliance",
      "poi_latitude": "39.578861",
      "poi_longitude": "-104.8776511",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 720-922-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx4Xte8WFbIcRUp2Grc001VA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_43a3eb85-291a-41f7-8880-3ac5cc4dd9ab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "custom",
      "poi_name": "Charter Communications - FGI",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6375 S Willow Dr, Greenwood Village, CO 80111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02cf-f68e-704a-b84f-e3ed7b026338.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cf-f68e-704a-b84f-e3ed7b026338",
        "storage_key": "property/6767906449166793/019d02cf-f68e-704a-b84f-e3ed7b026338.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11733155270649037061&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "charter-communications---fgi",
      "poi_latitude": "39.6030435",
      "poi_longitude": "-104.8870399",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-01fa-744a-af25-f38c557ae49d",
        "storage_key": "property/6767906449166793/019d02d0-01fa-744a-af25-f38c557ae49d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWdDhcTGHbIcRBcGJwY2K1KI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_8d778e74-bb9f-4b43-97da-74b7b2b75aa3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_674a935e-7b4c-442f-b14c-0b332260c165",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a9c9c941-e3bf-4233-9338-dd2789dd3878",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_22576a8c-333a-45be-91f0-9b53960555a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d272e01c-233d-45df-9849-c023be4b756e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_52dbd88b-0d8b-4b47-9f17-0abee864b0ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_8bf8ce4b-1992-4141-afa3-de6abc2db1f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "rating": "5.0",
      "name": "Melanie Michaels",
      "text": "My husband and I moved into V-Esprit six months ago after visiting a dozen other senior communities in the Denver area. Nothing compared to this community and we felt “at home” as soon as we walked into one of the spacious patio homes. V-Esprit has a warm and welcoming feel, there are lots of activities, and the other residents have been really fun to get to know. Peter, Cindy, Mary and the rest of the staff are amazing—so friendly and helpful. They make it easy to be as involved as one wants to be.\nThe rent includes membership in the Shalom Park Health Center where we work out in the gym, take classes, and can use the pool. This 14-acre campus has mature landscaping, great walking sidewalks, and gorgeous views of the Front Range. It’s a hidden gem and we’re so happy we found it!",
      "date": "2024-09-20",
      "title": ""
    },
    {
      "id": "custom_e915eb76-21f3-4828-9d11-d65803c35cfd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "rating": "5.0",
      "name": "David Novick",
      "text": "My wife and I are searching for an active adult community in the Denver suburbs and recently visited V-Esprit. It has become our first choice among the various communities we toured. The location is absolutely beautiful and the amenities are outstanding. The amount of available activities and the fitness facilities are second to none.\n\nWe had the opportunity to meet several community residents and staff members who were really friendly and helpful. Another aspect that stood out for us was that we met with the founding owner of the entire development, Peter Torrens, who personally conducted both a first and second tour for us. He took the time to patiently and openly answer all of our questions and explain the details in becoming residents of V-Esprit. We found it interesting and refreshing that the community has an owner who is on-site regularly and takes great personal pride in it, as opposed to a large corporation with multiple properties.\n\nOverall, we are truly excited about the prospect of moving to V-Esprit in the near future.",
      "date": "2024-10-21",
      "title": ""
    },
    {
      "id": "custom_b830789f-0bd2-4cf2-b819-f64b47f738ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "rating": "5.0",
      "name": "elaine barron",
      "text": "Even though we just moved into V-Esprit a few days ago, we have had a warm welcome from residents, staff, and council leaders. In particular, Peter, the leasing manager, Cindy, the executive director, Sal, the Maintenance Supervisor, and Susan, the concierge, have been so supportive and informative. Their professional expertise and kindness have made the rental and moving-in processes smooth and pleasant. Our patio home is immaculate, spacious, and filled with light. We can see the mountains from our sunroom windows. The V-Esprit community itself is beautifully landscaped, and the neighbors are as warm as the Denver sun.",
      "date": "2024-09-19",
      "title": ""
    },
    {
      "id": "custom_31f689b3-8dfe-4a46-a5d2-4f3a5a8c23f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "rating": "5.0",
      "name": "Cynthia Minor",
      "text": "My husband and I moved into V-Esprit last month. We love it here, and it immediately felt like home! We did not make this decision lightly. We looked at many places in the Denver/Boulder area, and we kept coming back to V-Esprit as the place we wanted to live. So, we put our name on a waiting list and were thrilled when Peter called to let us know an apartment was available. There’s a reason the place is 100% occupied; it’s that desirable. Here’s why we think it’s the best:\n\n1)\tThe V-Esprit Team. From the moment we met Peter and he gave us our first tour, we saw how much he cares about this place and its residents. The entire team: Peter, Cindy, Susan, Sal, Robert, Janeth, Mary, Josie, Jesse, and Christina (apologies to anyone I may have missed) all go out of their way to make living here an enjoyable experience. No matter what their job is, each one will go above and beyond to accommodate the residents. As Cindy, the Operations Manager, says, “Everyone does everything.” It seems to be true. Like Disney employees, every V-Esprit employee seems to be empowered with a direct line of sight to the customer and a mission to create happiness.\n\n2)\tThe Residents. The people who live here all seem happy and friendly. It’s a diverse population with people from all geographic areas and walks of life, and there’s a nice mix of couples as well as singles. They are independent, active seniors. We have met several couples who, like us, searched for a long time and found the vibe at V-Esprit to be the best. People who have lived here for years as well as those who just moved in all tell us it’s the best decision they ever made. Everyone is open and welcoming. There are no cliques or cattiness that we have encountered. In fact, my husband said, “Have you noticed that no one here complains?”\n\n3)\tThe Community and the Amenities. It was so easy to make friends here. Part is because of the residents, but much is because of the way V-Esprit is run, the team that makes it happen, and the lifestyle they offer. They provide a variety of activities, and everyone is welcome to join in. In addition, residents can create activities based on their own interests and expertise. There are opportunities to eat at the local bistro on campus, to eat out (with group outings), to eat in (delivered to your door), and to eat among your neighbors (sponsored and served on-campus by the V-Esprit team). Free membership to the Wellness Center next door and proximity to Cherry Creek State Park make it easy to stay healthy and commune with nature. The campus is very walkable, but there are also golf cart rides available. In addition, they provide transportation to and from medical appointments as well as group outings to entertainment venues and shopping.\nSimply put, V-Esprit is a great place to live. I'm so glad to be here.",
      "date": "2024-09-13",
      "title": ""
    },
    {
      "id": "custom_5073eca0-31b8-4be5-9432-ae7a5bae0a71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "rating": "5",
      "name": "Jean Mason",
      "text": "We just moved  here in June and everything has been wonderful.  We love our patio home, the amazing views from our sun porch and from all the walkways, the neighbors and the staff. There are lots of classes and groups and fun activities. It is easy to fill my calendar with things to enjoy, including time in the indoor pool (which has beautiful mountain views and a lazy river). We feel blessed to be here.",
      "date": "2026-09-04",
      "title": "false"
    },
    {
      "id": "custom_c21e3698-b1c6-4e02-85fc-b510f8c4d176",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "rating": "5",
      "name": "Nancy F.",
      "text": "My husband and I have been living at V-Esprit after spending 30 years in Evergreen.  A perfect choice.  The staff here is amazing, always ready to help, to laugh, and to make sure our needs are met with a smile.  It's a relatively small and friendly community so it's easy to make friends and find others who share one's interests.  Tons of activities to accommodate everyone, from opera and Broadway to bingo and book club.  We have use of a great gym and pool, with complimentary fitness classes. All in all, we're loving living at V-Esprit!",
      "date": "2026-10-05",
      "title": "false"
    },
    {
      "id": "custom_fa971c41-eb09-4e35-82c6-7a93629681da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "rating": "5",
      "name": "John Grant",
      "text": "I was flown to Denver to the hospital from Pagosa Springs for cancer treatment. After 14 days in the hospital, I was needing a place in Denver. My family went to V-Esprit to see if there were any possibilities of our renting a place for a couple of months. The staff here were so kind and found us a 2 bedroom garden home for us to rent for a couple of months! And…. What a place it is! We met so many kind and friendly people here. Made many new friendships in the community. They always had something going on for us to join in on. Just a real beautiful place with real beautiful people. We are returning home, but will certainly leave a piece of our hearts here and will hopefully return to visit all of our new friends!",
      "date": "2026-08-03",
      "title": "false"
    },
    {
      "id": "custom_129bb01f-95f3-4078-a92a-ccbb986593be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "rating": "5",
      "name": "Joanne Cardinal",
      "text": "I highly recommend V-Esprit. It is extremely well run with multiple varied activities and a very personable staff. I have lived here 4 months. I was seriously ill with Long Covid; at this point I am the happiest I have been since before my illness. Everyone I have met is very happy here which makes for a very positive environment. My apartment is beautiful, the kitchen extremely well designed. I am grateful I found this senior living community.",
      "date": "2026-04-27",
      "title": "false"
    },
    {
      "id": "custom_a9cc8bbc-b193-4345-bd95-733743ea005e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "rating": "5",
      "name": "Gayle Felder",
      "text": "Our family member transitioned from his large home in the mountains to a 2 bedroom + sunroom. It had been totally remodeled and looked new. The facility is lovely and the staff are helpful and polite . There are a lot of activities available. Recommend highly!\n",
      "date": "2026-03-05",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-apartments-with-cocktail-bar-aurora",
      "search_query": "apartments with cocktail bar in Aurora CO",
      "category": "Amenity",
      "h1_title": "Apartments with Cocktail Bar in Aurora, CO",
      "h2_subtitle": "Discover V Esprit's luxury apartments featuring a cocktail bar in Aurora, CO. Experience vibrant community living and exclusive amenities.",
      "page_copy": "Experience the vibrant lifestyle at V Esprit, where luxury meets comfort in Aurora, CO. Our exceptional community offers residents unique gathering spaces, including a stylish cocktail bar perfect for socializing with neighbors or unwinding after a long day. Conveniently located on a stunning 14-acre campus, V Esprit blends relaxation and sophistication.\n\nExplore the exquisite amenities that make V Esprit stand out. Beyond the chic cocktail bar, residents enjoy access to beautifully maintained walking paths, and an award-winning swimming pool with lap lanes. Embrace a sense of community and elevate your living experience in Aurora's most coveted neighborhood. Whether you're stepping out to meet friends or indulge in some personal time, V Esprit has everything you need for a fulfilled lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Cocktail Bar in Aurora, CO",
      "seo_description": "Explore V Esprit in Aurora, CO, featuring luxurious apartments with a cocktail bar and exclusive amenities like a swimming pool and walking paths.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-luxury-apartments-with-theater-arapahoe",
      "search_query": "luxury apartments with theater near Arapahoe County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Theater in Arapahoe County",
      "h2_subtitle": "Explore V Esprit's elegant apartments featuring an on-site theater near Arapahoe County. Enjoy top-tier amenities and a vibrant community lifestyle.",
      "page_copy": "Welcome to V Esprit, where luxury dictates every detail of the living experience close to Arapahoe County. Our community proudly features elegant apartments complemented by impressive amenities including an on-site theater. Imagine unwinding in the comfort of your home, then stepping into a cinema lounge right at your doorstep.\n\nLocated on a picturesque 14-acre campus, V Esprit offers more than just movie nights. Residents can savor the charming cocktail bar, stroll down the scenic walking paths, or swim laps in the award-winning pool. This distinctive blend of sophistication and community creates a welcoming space for those seeking a luxury apartment experience near Arapahoe County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Theater in Arapahoe County",
      "seo_description": "Discover luxury living at V Esprit near Arapahoe County, offering exquisite apartments and vibrant amenities including a theater and swimming pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-mountain-view-apartments-near-cherry-creek",
      "search_query": "mountain view apartments near Cherry Creek State Park",
      "category": "Amenity",
      "h1_title": "Mountain View Apartments by Cherry Creek State Park",
      "h2_subtitle": "Enjoy breathtaking mountain views at V Esprit, located near Cherry Creek State Park. Experience serene living with exceptional amenities.",
      "page_copy": "Nestled near the scenic Cherry Creek State Park, V Esprit offers residents breathtaking mountain view apartments that elevate the art of living in Aurora, CO. With its prime location, our community captures the natural beauty that surrounds Cherry Creek, providing a serene retreat to come home to every day.\n\nAt V Esprit, luxury living comes with a blend of impressive amenities. Our residents enjoy not only the picturesque landscapes but also a cocktail bar and an award-winning swimming pool with lap lanes. Spend your weekends exploring the 14-acre campus with its inviting walking paths or simply relax and take in the awe-inspiring mountain views. Make everyday special with V Esprit's unparalleled location and lifestyle offerings.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mountain View Apartments near Cherry Creek Park",
      "seo_description": "Discover stunning mountain view apartments at V Esprit, close to Cherry Creek State Park, with exceptional amenities including a cocktail bar and pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-apartments-award-winning-pool-aurora",
      "search_query": "Aurora CO apartments with award-winning swimming pool",
      "category": "Amenity",
      "h1_title": "Aurora CO Apartments with Award-Winning Pool",
      "h2_subtitle": "Discover V Esprit's apartments in Aurora, CO, featuring an award-winning swimming pool with lap lanes. Experience luxury living with exclusive amenities.",
      "page_copy": "Welcome to V Esprit, a premier apartment community in Aurora, CO, where residents enjoy an award-winning swimming pool with lap lanes. This outstanding feature is ideal for both relaxation and fitness, making it a centerpiece of our luxurious amenities. Surrounded by beautifully designed common spaces, the pool encourages a vibrant community atmosphere.\n\nSituated on a breathtaking 14-acre campus, V Esprit offers so much more than just a stunning pool. Residents can indulge in our stylish cocktail bar or take a leisurely walk along our scenic walking paths. The unique blend of comfort and convenience at V Esprit makes it a standout choice for those seeking premium apartment living in Aurora, CO.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Aurora CO Apartments with Award-Winning Pool",
      "seo_description": "Find luxury living at V Esprit in Aurora, CO, featuring apartments with an award-winning swimming pool and other exclusive amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-apartments-beauty-salon-spa-80015",
      "search_query": "apartments with beauty salon and spa 80015",
      "category": "Amenity",
      "h1_title": "Apartments with Beauty Salon and Spa in 80015",
      "h2_subtitle": "Experience luxury living at V Esprit, featuring apartments with access to a beauty salon and spa in the 80015 area. Elevate your lifestyle with top-tier amenities.",
      "page_copy": "V Esprit offers an exquisite living experience in the 80015 area, providing residents with exceptional amenities including access to a beauty salon and spa. This ensures that residents can enjoy pampering and relaxation moments right at their doorstep, enhancing their day-to-day living experience. Whether you're preparing for a night out or just seeking a tranquil escape, our salon and spa cater to your needs.\n\nLocated in Aurora, CO, V Esprit's community is designed for those who appreciate luxury and convenience. Beyond the beauty salon and spa, residents benefit from amenities like a cocktail bar, scenic walking paths, and an award-winning swimming pool with lap lanes. Our 14-acre campus supports a rich lifestyle filled with activities and community engagement, making V Esprit a perfect choice for those residing in the 80015 zip code.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Beauty Salon and Spa in 80015",
      "seo_description": "Discover upscale living at V Esprit in 80015, featuring stylish apartments with a beauty salon, spa, and other luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-two-bedroom-apartments-aurora",
      "search_query": "two bedroom apartments Aurora CO",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Aurora CO",
      "h2_subtitle": "Explore V Esprit's spacious two-bedroom apartments in Aurora, CO. Experience modern living with a range of premium amenities.",
      "page_copy": "At V Esprit, discover the perfect blend of comfort and space with our two-bedroom apartments located in the heart of Aurora, CO. These thoughtfully designed floor plans offer ample living space, making them ideal for families, roommates, or anyone seeking extra room for a home office or guest accommodation. Each apartment highlights the modern conveniences and tasteful finishes that fit today's lifestyle.\n\nThe community at V Esprit enhances apartment living with a variety of amenities. Residents can unwind at the cocktail bar, swim laps in the award-winning pool, or stroll through the beautifully landscaped 14-acre campus. Located close to local conveniences and with easy access to the vibrant city life and natural beauty of Aurora, our two-bedroom apartments provide a comfortable sanctuary with everything you need right at your doorstep.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Aurora CO",
      "seo_description": "Find spacious two-bedroom apartments at V Esprit in Aurora, CO, featuring modern amenities and a beautiful community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-one-bedroom-apartments-arapahoe-county",
      "search_query": "one bedroom apartments Arapahoe County",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Arapahoe County",
      "h2_subtitle": "Discover modern one-bedroom apartments at V Esprit in Arapahoe County. Enjoy a vibrant community with unmatched amenities and stylish living spaces.",
      "page_copy": "If you're seeking a modern, stylish home, V Esprit offers exceptional one-bedroom apartments in Arapahoe County. These spacious apartments are designed with the perfect balance of functionality and comfort, ideal for singles or couples looking for a cozy yet sophisticated space. Each unit is crafted with high-quality features to ensure a comfortable living experience.\n\nSituated within the vibrant V Esprit community, residents have access to an array of outstanding amenities. Enjoy the cocktail bar, unwind by the award-winning swimming pool, or take peaceful walks along the community’s scenic paths. With a 14-acre campus, the community offers ample opportunities for relaxation and socialization, making it a top choice for residents in Arapahoe County looking for more than just an apartment, but a place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Arapahoe County",
      "seo_description": "Explore stylish one-bedroom apartments at V Esprit in Arapahoe County, featuring excellent amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-apartments-near-hca-healthone-aurora",
      "search_query": "apartments near HCA HealthONE Aurora CO",
      "category": "Hospital",
      "h1_title": "Apartments Near HCA HealthONE in Aurora, CO",
      "h2_subtitle": "Live conveniently near HCA HealthONE at V Esprit in Aurora, CO. Discover a community offering luxurious amenities and modern living spaces.",
      "page_copy": "V Esprit offers an ideal location for those looking to live near HCA HealthONE in Aurora, CO. Our community is perfect for healthcare professionals, patients, and families who appreciate the convenience of proximity to one of the leading healthcare facilities in the area. The thoughtfully designed apartments ensure a comfortable and easy commute for those working or receiving care at HealthONE.\n\nBeyond the prime location, V Esprit provides an impressive range of amenities for residents. Enjoy a vibrant social life with our cocktail bar and ample gathering spaces, or relax at our award-winning swimming pool and expansive walking paths. The 14-acre campus in Arapahoe County caters to a dynamic lifestyle, blending convenience with serenity, ideal for anyone wanting to be near the healthcare hub of Aurora.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near HCA HealthONE in Aurora, CO",
      "seo_description": "Find comfortable living at V Esprit, conveniently located near HCA HealthONE in Aurora, CO, with luxurious amenities and modern accommodations.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-apartments-close-to-adventhealth-parker",
      "search_query": "apartments close to AdventHealth Parker 80015",
      "category": "Hospital",
      "h1_title": "Apartments Close to AdventHealth Parker",
      "h2_subtitle": "Discover V Esprit's convenient location near AdventHealth Parker. Enjoy stylish living with top-tier amenities in the 80015 area.",
      "page_copy": "Located in Aurora's desirable 80015 area, V Esprit provides stylish apartment living just a short drive from AdventHealth Parker. Whether you're a healthcare professional looking for a nearby residence or a patient seeking comfort while receiving care, our community is perfectly situated for an easy commute. \n\nResidents of V Esprit appreciate the blend of convenience and luxury offered by the community's broad range of amenities. Enjoy social gatherings at the cocktail bar or unwind with a swim in the award-winning pool. The well-maintained walking paths and ample common spaces encourage relaxation and a vibrant lifestyle. At V Esprit, you're not just choosing an apartment, but a home close to the essentials like AdventHealth Parker and much more.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to AdventHealth Parker",
      "seo_description": "V Esprit offers beautiful apartments conveniently close to AdventHealth Parker in Aurora's 80015 area, featuring excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-apartments-near-cherry-creek-state-park",
      "search_query": "apartments near Cherry Creek State Park Aurora CO",
      "category": "Park",
      "h1_title": "Apartments Near Cherry Creek State Park",
      "h2_subtitle": "Experience nature's beauty at V Esprit with easy access to Cherry Creek State Park in Aurora, CO. Enjoy a vibrant community and top-notch amenities.",
      "page_copy": "V Esprit offers an unparalleled living experience with beautifully designed apartments near Cherry Creek State Park in Aurora, CO. Ideal for nature enthusiasts or anyone who appreciates quick access to hiking trails, picnicking spots, and water activities, our community is just a stone's throw away from this local treasure.\n\nBeyond the stunning natural surroundings, V Esprit provides a host of amenities designed to enhance your lifestyle. Indulge in leisure time at our cocktail bar or swim laps in the award-winning pool. The expansive 14-acre campus features walking paths and gathering areas perfect for socializing or unwinding. Discover the blend of outdoor adventure and unparalleled community experience V Esprit offers near Cherry Creek State Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cherry Creek State Park",
      "seo_description": "Live at V Esprit in Aurora, CO, near Cherry Creek State Park. Enjoy scenic beauty and community amenities in our excellent apartment homes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-apartments-close-to-centennial-center-park",
      "search_query": "apartments close to Centennial Center Park Arapahoe County",
      "category": "Park",
      "h1_title": "Apartments Close to Centennial Center Park",
      "h2_subtitle": "Enjoy easy access to Centennial Center Park from V Esprit. Discover luxurious living with top amenities in Arapahoe County.",
      "page_copy": "Nestled in the welcoming community of Arapahoe County, V Esprit offers stylish apartments conveniently close to Centennial Center Park. Ideal for families or outdoor lovers, the park is a hub of activity with playgrounds, picnic areas, and walking trails. Living nearby means spontaneous outings and quick weekend escapades are just minutes away.\n\nV Esprit doesn’t just offer proximity to outdoor fun; it's a haven of luxury and comfort. Our community features a cocktail bar for social occasions and an award-winning swimming pool perfect for relaxation or exercise. With ample walking paths and gathering spaces spread over a 14-acre campus, you’ll find the perfect balance between adventure and tranquility right here at V Esprit, near Centennial Center Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Centennial Center Park",
      "seo_description": "V Esprit in Arapahoe County offers luxurious living near Centennial Center Park. Enjoy top amenities and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-apartments-near-cherry-creek-dola-80015",
      "search_query": "apartments near Cherry Creek ​DOLA zip 80015",
      "category": "Park",
      "h1_title": "Apartments Near Cherry Creek DOLA 80015",
      "h2_subtitle": "Live conveniently near Cherry Creek DOLA in the 80015 zip code. Discover the vibrant lifestyle at V Esprit with unmatched amenities.",
      "page_copy": "V Esprit presents an exceptional living option for those seeking apartments near Cherry Creek DOLA in the 80015 zip code. Our location offers both convenience and access to vibrant community activities. Cherry Creek DOLA is perfect for dog lovers and offers scenic spots ideal for a daily stroll with your furry friend.\n\nAt V Esprit, we amplify your living experience with a variety of amenities designed to enrich your lifestyle. Whether you're diving into relaxation at our award-winning swimming pool or enjoying evening cocktails at our on-site bar, there's always something to experience. The expansive 14-acre campus offers ample walking paths and gathering spaces, making it easy to enjoy social and relaxation opportunities. Discover life at V Esprit, where comfort and location meet just steps from Cherry Creek DOLA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cherry Creek DOLA 80015",
      "seo_description": "Discover V Esprit near Cherry Creek DOLA in the 80015 area. Enjoy premier apartment living with fantastic amenities and a pet-friendly environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-apartments-by-james-a-bible-park",
      "search_query": "apartments by James A. Bible Park Aurora",
      "category": "Park",
      "h1_title": "Apartments by James A. Bible Park",
      "h2_subtitle": "Discover the convenience of living near James A. Bible Park at V Esprit in Aurora. Enjoy an active lifestyle with top-notch amenities.",
      "page_copy": "V Esprit is the perfect choice for those seeking apartments by James A. Bible Park in Aurora. This location offers the ultimate suburban oasis, complete with beautiful trails, open fields, and recreational areas that make it ideal for outdoor enthusiasts and families alike.\n\nLiving at V Esprit means embracing a community-focused lifestyle, with a spectrum of amenities designed to cater to your needs. From a cocktail bar for social connections to an award-winning pool complete with lap lanes, there's something for everyone. Our expansive 14-acre campus invites exploration with its thoughtfully designed walking paths and common spaces. Experience the joy of living near James A. Bible Park, where outdoor beauty meets incredible community living at V Esprit.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by James A. Bible Park",
      "seo_description": "Find your ideal home at V Esprit, located near James A. Bible Park in Aurora. Experience an active lifestyle with exceptional community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-apartments-near-belleview-station",
      "search_query": "apartments near Belleview Station Aurora CO",
      "category": "Transit",
      "h1_title": "Apartments Near Belleview Station CO",
      "h2_subtitle": "Explore convenient living at V Esprit, minutes from Belleview Station in Aurora, CO. Enjoy luxury amenities and easy access to transit.",
      "page_copy": "V Esprit offers the ideal living solution for anyone searching for apartments near Belleview Station in Aurora, CO. This prime location ensures effortless access to public transit, making your daily commute smooth and stress-free. Belleview Station is a vibrant area engineered for connectivity, offering immediate access to shopping, dining, and recreational venues.\n\nResidents at V Esprit enjoy a perfect blend of luxurious community living and exciting urban convenience. Our exquisite amenities range from a welcoming cocktail bar to our award-winning swimming pool complete with lap lanes. The property's walking paths and extensive gathering spaces are spread across a 14-acre campus, perfect for unwinding or socializing. Live close to Belleview Station and enjoy both the tranquility of a secluded community and the vibrancy of urban life at V Esprit.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Belleview Station CO",
      "seo_description": "Discover luxury living at V Esprit, just minutes from Belleview Station in Aurora, CO. Enjoy top amenities and seamless access to transit and urban activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-apartments-close-to-arapahoe-village-station",
      "search_query": "apartments close to Arapahoe at Village Center Station",
      "category": "Transit",
      "h1_title": "Apartments Close to Arapahoe Village Center",
      "h2_subtitle": "Find ideal living near Arapahoe at Village Center Station. V Esprit in Aurora offers luxury and convenience with top community amenities.",
      "page_copy": "V Esprit stands out as the premier destination for those seeking apartments close to Arapahoe at Village Center Station. Offering seamless access to top-notch transit, this location is perfect for professionals and commuters looking for convenience coupled with comfort.\n\nResidents at V Esprit enjoy more than just a strategic location. Our community boasts an extensive range of amenities, including a vibrant cocktail bar and an award-winning swimming pool with lap lanes. The expansive, beautifully landscaped 14-acre campus features abundant walking paths and a variety of gathering spaces, making it easy to balance work, leisure, and socialization. Experience the unparalleled lifestyle at V Esprit where comfort meets connectivity just moments from Arapahoe at Village Center Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Arapahoe Village Center",
      "seo_description": "Live luxuriously near Arapahoe at Village Center Station. V Esprit offers convenience, premier amenities, and a welcoming community in Aurora.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-southmoor-station-nearby-apartments-80015",
      "search_query": "Southmoor Station nearby apartments 80015",
      "category": "Transit",
      "h1_title": "Southmoor Station Nearby Apartments 80015",
      "h2_subtitle": "Choose V Esprit for nearby apartments to Southmoor Station in the 80015 area. Enjoy top amenities in a serene setting.",
      "page_copy": "Located in Aurora's desirable 80015 zip code, V Esprit offers the ideal home for those searching for Southmoor Station nearby apartments. This prime location provides quick access to one of the most convenient transit stations, making daily travel around the city a breeze.\n\nAt V Esprit, residents benefit from an array of thoughtfully curated amenities that enhance everyday living. Our community features a lively cocktail bar for socializing, an award-winning swimming pool with lap lanes, and over 14 acres of beautifully maintained grounds that invite exploration and relaxation. Our expansive walking paths and numerous gathering spaces make V Esprit more than just an apartment complex—it's a lifestyle destination. Embrace the perfect blend of accessibility and tranquility close to Southmoor Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Southmoor Station Nearby Apartments 80015",
      "seo_description": "Find luxury living near Southmoor Station in the 80015 area. V Esprit offers top-tier amenities in a prime Aurora location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166793",
      "source": "generator",
      "page_item_url": "v-esprit-county-line-station-area-apartments",
      "search_query": "County Line Station area apartments Aurora",
      "category": "Transit",
      "h1_title": "County Line Station Area Apartments Aurora",
      "h2_subtitle": "Discover V Esprit, near County Line Station in Aurora. Top amenities and convenience for modern living await you here.",
      "page_copy": "Nestled in the vibrant city of Aurora, V Esprit offers an exceptional living experience for those seeking County Line Station area apartments. With the station nearby, commuting is simplified, providing residents with easy access to the entire city and beyond.\n\nFeaturing an array of luxurious amenities, V Esprit is more than just a place to live. Residents can unwind at the lively cocktail bar, swim in the award-winning pool featuring lap lanes, or explore the scenic walking paths on our expansive 14-acre campus. The community has plenty of social gathering spaces that promote interaction and relaxation. When you choose V Esprit, you're choosing a lifestyle enriched with convenience and comfort, perfectly situated in the County Line Station area of Aurora.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "County Line Station Area Apartments Aurora",
      "seo_description": "Explore V Esprit, offering luxury apartments near County Line Station in Aurora. Experience modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6026"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10715005392"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Pathfinder 4"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Pathfinder Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "112VSP"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "41615633440"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "ER100107678"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/V Esprit/scheduletourwidget/SkmrA8i6vB3ATtRNoX/"
    }
  ],
  "custom_csm": "none",
  "custom_qb_id": "6026",
  "custom_repli_id": "10715005392",
  "custom_rollout_phase": "Pathfinder 4",
  "custom_vibesites_theme": "Pathfinder Preferred",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "none",
  "custom_aim_property_code": "112VSP",
  "custom_hubspot_company_id": "41615633440",
  "custom_social_subscription": "none",
  "custom_website_subscription": "none",
  "custom_broker_license_number": "ER100107678",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/V Esprit/scheduletourwidget/SkmrA8i6vB3ATtRNoX/",
  "custom_audioeye_site_id": "ed90bd7c-e8e8-4dc9-8515-65b7147d2aac",
  "custom_audioeye_site_hash": "b8730f4ac878616c70895338af9d2fdb"
};

export const generatedAt = '2026-10-08T21:16:46.568Z';
